import { apiRTK as api } from "./src/apiRTK";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postMultiplacerArticlesByCompCodes: build.query<
      PostMultiplacerArticlesByCompCodesApiResponse,
      PostMultiplacerArticlesByCompCodesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/articles/by-comp-codes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMcbimSpaces: build.query<
      GetMcbimSpacesApiResponse,
      GetMcbimSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces`,
        params: {
          projectNo: queryArg.projectNo,
          jobId: queryArg.jobId,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    getMcbimSpacesInProject: build.query<
      GetMcbimSpacesInProjectApiResponse,
      GetMcbimSpacesInProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/spaces.in.project`,
        params: {
          projectNo: queryArg.projectNo,
          longName: queryArg.longName,
        },
      }),
    }),
    getMcbimItem: build.query<GetMcbimItemApiResponse, GetMcbimItemApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/item`,
        params: {
          projectNo: queryArg.projectNo,
          itemId: queryArg.itemId,
        },
      }),
    }),
    getMcbimItemsInSpace: build.query<
      GetMcbimItemsInSpaceApiResponse,
      GetMcbimItemsInSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items.in.space`,
        params: {
          spaceId: queryArg.spaceId,
          spaceName: queryArg.spaceName,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFileFloorVersions: build.query<
      GetMcbimFileFloorVersionsApiResponse,
      GetMcbimFileFloorVersionsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/file.floor.versions`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFileFloorVersionsAll: build.query<
      GetMcbimFileFloorVersionsAllApiResponse,
      GetMcbimFileFloorVersionsAllApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/file.floor.versions.all`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimSingleMcbimSpace: build.query<
      GetMcbimSingleMcbimSpaceApiResponse,
      GetMcbimSingleMcbimSpaceApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/single-mcbim-space`,
        params: {
          projectNo: queryArg.projectNo,
          name: queryArg.name,
        },
      }),
    }),
    postMcbimItems: build.query<
      PostMcbimItemsApiResponse,
      PostMcbimItemsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMcbimBuildingStories: build.query<
      GetMcbimBuildingStoriesApiResponse,
      GetMcbimBuildingStoriesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/building-stories`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimDisciplines: build.query<
      GetMcbimDisciplinesApiResponse,
      GetMcbimDisciplinesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/disciplines`,
        params: {
          projectNo: queryArg.projectNo,
          buildingStoryName: queryArg.buildingStoryName,
        },
      }),
    }),
    getMcbimItemsUniqueClasses: build.query<
      GetMcbimItemsUniqueClassesApiResponse,
      GetMcbimItemsUniqueClassesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items/unique-classes`,
        params: {
          projectNo: queryArg.projectNo,
          buildingStoryName: queryArg.buildingStoryName,
        },
      }),
    }),
    getMcbimCeilingLines: build.query<
      GetMcbimCeilingLinesApiResponse,
      GetMcbimCeilingLinesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/ceiling-lines`,
        params: {
          projectNo: queryArg.projectNo,
          jobId: queryArg.jobId,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    getMcbimPipeSeries: build.query<
      GetMcbimPipeSeriesApiResponse,
      GetMcbimPipeSeriesApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/pipe-series`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimFrags: build.query<GetMcbimFragsApiResponse, GetMcbimFragsApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/frags`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMcbimItems3DByIds: build.query<
      PostMcbimItems3DByIdsApiResponse,
      PostMcbimItems3DByIdsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items-3d-by-ids`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMcbimItems3DNearCoordinate: build.query<
      PostMcbimItems3DNearCoordinateApiResponse,
      PostMcbimItems3DNearCoordinateApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/items-3d-near-coordinate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRooms: build.query<
      PostMultiplacerRoomsApiResponse,
      PostMultiplacerRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerSingleRoom: build.query<
      GetMultiplacerSingleRoomApiResponse,
      GetMultiplacerSingleRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/single-room`,
        params: {
          roomNumber: queryArg.roomNumber,
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMultiplacerStandardRooms: build.query<
      GetMultiplacerStandardRoomsApiResponse,
      GetMultiplacerStandardRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/standard-rooms`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerRoomsCeilingFreeTilesByFloor: build.query<
      PostMultiplacerRoomsCeilingFreeTilesByFloorApiResponse,
      PostMultiplacerRoomsCeilingFreeTilesByFloorApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/ceiling-free-tiles-by-floor`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerRoomLock: build.mutation<
      PutMultiplacerRoomLockApiResponse,
      PutMultiplacerRoomLockApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/lock`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeiling: build.mutation<
      PostMultiplacerRoomCeilingApiResponse,
      PostMultiplacerRoomCeilingApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerAirflowsImport: build.mutation<
      PostMultiplacerAirflowsImportApiResponse,
      PostMultiplacerAirflowsImportApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/airflows/import`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomValidation: build.mutation<
      DeleteMultiplacerRoomValidationApiResponse,
      DeleteMultiplacerRoomValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerRoomValidationDecisionStatus: build.mutation<
      PostMultiplacerRoomValidationDecisionStatusApiResponse,
      PostMultiplacerRoomValidationDecisionStatusApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/status`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionComment: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentApiResponse,
      PostMultiplacerRoomValidationDecisionCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentUpdate: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse,
      PostMultiplacerRoomValidationDecisionCommentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomValidationDecisionCommentDelete: build.mutation<
      PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse,
      PostMultiplacerRoomValidationDecisionCommentDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/validation-decision/comment/delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingComment: build.mutation<
      PostMultiplacerRoomCeilingCommentApiResponse,
      PostMultiplacerRoomCeilingCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingCommentUpdate: build.mutation<
      PostMultiplacerRoomCeilingCommentUpdateApiResponse,
      PostMultiplacerRoomCeilingCommentUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment/update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomCeilingCommentDelete: build.mutation<
      PostMultiplacerRoomCeilingCommentDeleteApiResponse,
      PostMultiplacerRoomCeilingCommentDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room/ceiling-comment/delete`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomSnapshotTrendByKey: build.query<
      PostMultiplacerRoomSnapshotTrendByKeyApiResponse,
      PostMultiplacerRoomSnapshotTrendByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/room-snapshot/trend-by-key`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomsRoomNumberingCalculateNrh: build.mutation<
      PostMultiplacerRoomsRoomNumberingCalculateNrhApiResponse,
      PostMultiplacerRoomsRoomNumberingCalculateNrhApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/calculate-nrh`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerRoomsRoomNumberingCalculationMetadata: build.query<
      GetMultiplacerRoomsRoomNumberingCalculationMetadataApiResponse,
      GetMultiplacerRoomsRoomNumberingCalculationMetadataApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/calculation-metadata`,
        params: {
          projectNo: queryArg.projectNo,
          methodKey: queryArg.methodKey,
          floorGlobalId: queryArg.floorGlobalId,
        },
      }),
    }),
    postMultiplacerRoomsUpdateCalculatedRoomNumbers: build.mutation<
      PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiResponse,
      PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/update-calculated-room-numbers`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerRoomsRoomNumberingManualValue: build.mutation<
      PutMultiplacerRoomsRoomNumberingManualValueApiResponse,
      PutMultiplacerRoomsRoomNumberingManualValueApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/manual-value`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomsRoomNumberingManualValue: build.mutation<
      DeleteMultiplacerRoomsRoomNumberingManualValueApiResponse,
      DeleteMultiplacerRoomsRoomNumberingManualValueApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/manual-value`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
          roomNumber: queryArg.roomNumber,
        },
      }),
    }),
    postMultiplacerRoomsRoomNumberingApproval: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerRoomsRoomNumberingApproval: build.mutation<
      DeleteMultiplacerRoomsRoomNumberingApprovalApiResponse,
      DeleteMultiplacerRoomsRoomNumberingApprovalApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
          roomNumber: queryArg.roomNumber,
        },
      }),
    }),
    postMultiplacerRoomsRoomNumberingApprovalBulk: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalBulkApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalBulkApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval/bulk`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerRoomsRoomNumberingApprovalBulkClear: build.mutation<
      PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiResponse,
      PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/approval/bulk-clear`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerRoomsRoomNumberingEvaluation: build.mutation<
      PutMultiplacerRoomsRoomNumberingEvaluationApiResponse,
      PutMultiplacerRoomsRoomNumberingEvaluationApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/rooms/room-numbering/evaluation`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevices: build.query<
      PostMultiplacerDevicesApiResponse,
      PostMultiplacerDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevicesSimilarRoomsWithIfcDesign: build.query<
      PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiResponse,
      PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices/similar-rooms-with-ifc-design`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDevicesSimilarRoomsWithDevices: build.query<
      PostMultiplacerDevicesSimilarRoomsWithDevicesApiResponse,
      PostMultiplacerDevicesSimilarRoomsWithDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devices/similar-rooms-with-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putMultiplacerDeviceUpdate: build.mutation<
      PutMultiplacerDeviceUpdateApiResponse,
      PutMultiplacerDeviceUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDeviceAddDevices: build.mutation<
      PostMultiplacerDeviceAddDevicesApiResponse,
      PostMultiplacerDeviceAddDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/add-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerMediaAssets: build.query<
      GetMultiplacerMediaAssetsApiResponse,
      GetMultiplacerMediaAssetsApiArg
    >({
      query: () => ({ url: `/multiplacer/media-assets` }),
    }),
    deleteMultiplacerMediaAssetsByKey: build.mutation<
      DeleteMultiplacerMediaAssetsByKeyApiResponse,
      DeleteMultiplacerMediaAssetsByKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/media-assets/${queryArg.key}`,
        method: "DELETE",
      }),
    }),
    getMultiplacerMediaAssetsMediaAssetKey: build.query<
      GetMultiplacerMediaAssetsMediaAssetKeyApiResponse,
      GetMultiplacerMediaAssetsMediaAssetKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/media-assets/:mediaAssetKey`,
        params: {
          mediaAssetKey: queryArg.mediaAssetKey,
        },
      }),
    }),
    postMultiplacerDeviceDeleteInRooms: build.mutation<
      PostMultiplacerDeviceDeleteInRoomsApiResponse,
      PostMultiplacerDeviceDeleteInRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-in-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerDeviceDeleteDevice: build.mutation<
      DeleteMultiplacerDeviceDeleteDeviceApiResponse,
      DeleteMultiplacerDeviceDeleteDeviceApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/device/delete-device`,
        method: "DELETE",
        params: {
          deviceId: queryArg.deviceId,
        },
      }),
    }),
    getAuthMe: build.query<GetAuthMeApiResponse, GetAuthMeApiArg>({
      query: () => ({ url: `/auth/me` }),
    }),
    getAuthDevUsers: build.query<
      GetAuthDevUsersApiResponse,
      GetAuthDevUsersApiArg
    >({
      query: () => ({ url: `/auth/dev-users` }),
    }),
    getAuthUsersByUserIdProfilePhoto: build.query<
      GetAuthUsersByUserIdProfilePhotoApiResponse,
      GetAuthUsersByUserIdProfilePhotoApiArg
    >({
      query: (queryArg) => ({
        url: `/auth/users/${queryArg.userId}/profile-photo`,
      }),
    }),
    getProjectSyncRuns: build.query<
      GetProjectSyncRunsApiResponse,
      GetProjectSyncRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/sync-runs`,
        params: {
          projectNo: queryArg.projectNo,
          limit: queryArg.limit,
          cursor: queryArg.cursor,
        },
      }),
    }),
    getMultiplacerAssetsSas: build.query<
      GetMultiplacerAssetsSasApiResponse,
      GetMultiplacerAssetsSasApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/assets/sas`,
        params: {
          target: queryArg.target,
          blobPath: queryArg.blobPath,
        },
      }),
    }),
    getMultiplacerDrofusInterfaceOccurrencesSyncSchedule: build.query<
      GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse,
      GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences-sync-schedule`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesSyncSchedule: build.mutation<
      PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences-sync-schedule`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDrofusInterfaceRuns: build.query<
      GetMultiplacerDrofusInterfaceRunsApiResponse,
      GetMultiplacerDrofusInterfaceRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/runs`,
        params: {
          limit: queryArg.limit,
          offset: queryArg.offset,
          projectNo: queryArg.projectNo,
          status: queryArg.status,
        },
      }),
    }),
    postMultiplacerDrofusInterfaceDeleteRun: build.mutation<
      PostMultiplacerDrofusInterfaceDeleteRunApiResponse,
      PostMultiplacerDrofusInterfaceDeleteRunApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/delete-run`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrences: build.query<
      PostMultiplacerDrofusInterfaceOccurrencesApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceRoomChanges: build.query<
      PostMultiplacerDrofusInterfaceRoomChangesApiResponse,
      PostMultiplacerDrofusInterfaceRoomChangesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/room-changes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceProjectChangeEvents: build.query<
      PostMultiplacerDrofusInterfaceProjectChangeEventsApiResponse,
      PostMultiplacerDrofusInterfaceProjectChangeEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/project-change-events`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceProjectChangeEventAttributeOptions:
      build.query<
        PostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsApiResponse,
        PostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/multiplacer/drofus-interface/project-change-event-attribute-options`,
          method: "POST",
          body: queryArg.body,
        }),
      }),
    postMultiplacerDrofusInterfaceProjectChangeEventMmiOptions: build.query<
      PostMultiplacerDrofusInterfaceProjectChangeEventMmiOptionsApiResponse,
      PostMultiplacerDrofusInterfaceProjectChangeEventMmiOptionsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/project-change-event-mmi-options`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceProjectChangeEventsByRoom: build.query<
      PostMultiplacerDrofusInterfaceProjectChangeEventsByRoomApiResponse,
      PostMultiplacerDrofusInterfaceProjectChangeEventsByRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/project-change-events-by-room`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceArticles: build.query<
      PostMultiplacerDrofusInterfaceArticlesApiResponse,
      PostMultiplacerDrofusInterfaceArticlesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/articles`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrence: build.query<
      PostMultiplacerDrofusInterfaceOccurrenceApiResponse,
      PostMultiplacerDrofusInterfaceOccurrenceApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrence`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrenceByIfcGuid: build.query<
      PostMultiplacerDrofusInterfaceOccurrenceByIfcGuidApiResponse,
      PostMultiplacerDrofusInterfaceOccurrenceByIfcGuidApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrence-by-ifc-guid`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesInRoom: build.query<
      PostMultiplacerDrofusInterfaceOccurrencesInRoomApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesInRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences-in-room`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postTdroomUpsert: build.mutation<
      PostTdroomUpsertApiResponse,
      PostTdroomUpsertApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/upsert`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getTdroomSingle: build.query<
      GetTdroomSingleApiResponse,
      GetTdroomSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/tdroom/single`,
        params: {
          tdroomId: queryArg.tdroomId,
        },
      }),
    }),
    getTdroomAll: build.query<GetTdroomAllApiResponse, GetTdroomAllApiArg>({
      query: () => ({ url: `/tdroom/all` }),
    }),
    postAddProjectTdRooms: build.mutation<
      PostAddProjectTdRoomsApiResponse,
      PostAddProjectTdRoomsApiArg
    >({
      query: (queryArg) => ({
        url: `/add-project-td-rooms`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypes: build.query<
      GetMultiplacerDevicetypesApiResponse,
      GetMultiplacerDevicetypesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerDevicetypesAggregate: build.mutation<
      PostMultiplacerDevicetypesAggregateApiResponse,
      PostMultiplacerDevicetypesAggregateApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.aggregate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerDevicetypesStats: build.query<
      GetMultiplacerDevicetypesStatsApiResponse,
      GetMultiplacerDevicetypesStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/devicetypes.stats`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMlPredictCeilingDevices: build.mutation<
      PostMlPredictCeilingDevicesApiResponse,
      PostMlPredictCeilingDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/ml/predict-ceiling-devices`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMlPing: build.query<GetMlPingApiResponse, GetMlPingApiArg>({
      query: () => ({ url: `/ml/ping` }),
    }),
    putMultiplacerProjectsRoomSyncSettings: build.mutation<
      PutMultiplacerProjectsRoomSyncSettingsApiResponse,
      PutMultiplacerProjectsRoomSyncSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/room-sync-settings`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjectArticleValidation: build.query<
      GetMultiplacerProjectArticleValidationApiResponse,
      GetMultiplacerProjectArticleValidationApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/article-validation`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerProjectArticleValidationIgnored: build.mutation<
      PostMultiplacerProjectArticleValidationIgnoredApiResponse,
      PostMultiplacerProjectArticleValidationIgnoredApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/article-validation/ignored`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjectArticleColoring: build.query<
      GetMultiplacerProjectArticleColoringApiResponse,
      GetMultiplacerProjectArticleColoringApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/article-coloring`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    putMultiplacerProjectArticleColoring: build.mutation<
      PutMultiplacerProjectArticleColoringApiResponse,
      PutMultiplacerProjectArticleColoringApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/article-coloring`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectAddProject: build.mutation<
      PostMultiplacerProjectAddProjectApiResponse,
      PostMultiplacerProjectAddProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/add-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjects: build.query<
      GetMultiplacerProjectsApiResponse,
      GetMultiplacerProjectsApiArg
    >({
      query: () => ({ url: `/multiplacer/projects` }),
    }),
    postProjectDrofusUpdateSettings: build.mutation<
      PostProjectDrofusUpdateSettingsApiResponse,
      PostProjectDrofusUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerProjectsSingleProject: build.query<
      GetMultiplacerProjectsSingleProjectApiResponse,
      GetMultiplacerProjectsSingleProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/single-project`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postMultiplacerProjectEditProject: build.mutation<
      PostMultiplacerProjectEditProjectApiResponse,
      PostMultiplacerProjectEditProjectApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/project/edit-project`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectVentilationUpdateSettings: build.mutation<
      PostProjectVentilationUpdateSettingsApiResponse,
      PostProjectVentilationUpdateSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/ventilation.update-settings`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectsAddMember: build.mutation<
      PostMultiplacerProjectsAddMemberApiResponse,
      PostMultiplacerProjectsAddMemberApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/add-member`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectsInviteByEmail: build.mutation<
      PostMultiplacerProjectsInviteByEmailApiResponse,
      PostMultiplacerProjectsInviteByEmailApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/invite-by-email`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerProjectsUpdateMemberModules: build.mutation<
      PostMultiplacerProjectsUpdateMemberModulesApiResponse,
      PostMultiplacerProjectsUpdateMemberModulesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/projects/update-member-modules`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    ping: build.query<PingApiResponse, PingApiArg>({
      query: () => ({ url: `/ping` }),
    }),
    postFunctionsDrofusOccurrencesDetails: build.query<
      PostFunctionsDrofusOccurrencesDetailsApiResponse,
      PostFunctionsDrofusOccurrencesDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/occurrences/details`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusArticlesDetails: build.query<
      PostFunctionsDrofusArticlesDetailsApiResponse,
      PostFunctionsDrofusArticlesDetailsApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/articles/details`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getFunctionsPing: build.query<
      GetFunctionsPingApiResponse,
      GetFunctionsPingApiArg
    >({
      query: () => ({ url: `/functions/ping` }),
    }),
    postMultiplacerEnrichRoom: build.mutation<
      PostMultiplacerEnrichRoomApiResponse,
      PostMultiplacerEnrichRoomApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/enrich-room`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerSyncStart: build.mutation<
      PostMultiplacerSyncStartApiResponse,
      PostMultiplacerSyncStartApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/sync/start`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectDrofusVerifyConnection: build.mutation<
      PostProjectDrofusVerifyConnectionApiResponse,
      PostProjectDrofusVerifyConnectionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/drofus.verify-connection`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesSync: build.mutation<
      PostMultiplacerDrofusInterfaceOccurrencesSyncApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesSyncApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences/sync`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerDrofusInterfaceOccurrencesDiffLatest: build.mutation<
      PostMultiplacerDrofusInterfaceOccurrencesDiffLatestApiResponse,
      PostMultiplacerDrofusInterfaceOccurrencesDiffLatestApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/drofus-interface/occurrences/diff-latest`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusOccurrencesTest: build.query<
      PostFunctionsDrofusOccurrencesTestApiResponse,
      PostFunctionsDrofusOccurrencesTestApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/occurrences/test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusItemsOptionsTest: build.query<
      PostFunctionsDrofusItemsOptionsTestApiResponse,
      PostFunctionsDrofusItemsOptionsTestApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/items/options/test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusOccurrencesOptionsTest: build.query<
      PostFunctionsDrofusOccurrencesOptionsTestApiResponse,
      PostFunctionsDrofusOccurrencesOptionsTestApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/occurrences/options/test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusApiProbeTest: build.query<
      PostFunctionsDrofusApiProbeTestApiResponse,
      PostFunctionsDrofusApiProbeTestApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/api/probe/test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusOccurrencesLogsTest: build.query<
      PostFunctionsDrofusOccurrencesLogsTestApiResponse,
      PostFunctionsDrofusOccurrencesLogsTestApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/occurrences/logs/test`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusRoomsOccurrencesValidate: build.mutation<
      PostFunctionsDrofusRoomsOccurrencesValidateApiResponse,
      PostFunctionsDrofusRoomsOccurrencesValidateApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/rooms/occurrences/validate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postFunctionsDrofusRoomsOccurrencesLive: build.query<
      PostFunctionsDrofusRoomsOccurrencesLiveApiResponse,
      PostFunctionsDrofusRoomsOccurrencesLiveApiArg
    >({
      query: (queryArg) => ({
        url: `/functions/drofus/rooms/occurrences/live`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postSharedZodPing: build.mutation<
      PostSharedZodPingApiResponse,
      PostSharedZodPingApiArg
    >({
      query: (queryArg) => ({
        url: `/shared/zod-ping`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getSharedStaticDeviceTypeSettings: build.query<
      GetSharedStaticDeviceTypeSettingsApiResponse,
      GetSharedStaticDeviceTypeSettingsApiArg
    >({
      query: () => ({ url: `/shared/static/device-type-settings` }),
    }),
    postSharedCalculateEarthing: build.mutation<
      PostSharedCalculateEarthingApiResponse,
      PostSharedCalculateEarthingApiArg
    >({
      query: (queryArg) => ({
        url: `/shared/calculate-earthing`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postMultiplacerReleaseNotesDeployNotes: build.mutation<
      PostMultiplacerReleaseNotesDeployNotesApiResponse,
      PostMultiplacerReleaseNotesDeployNotesApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/deploy-notes`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerReleaseNotesPublished: build.query<
      GetMultiplacerReleaseNotesPublishedApiResponse,
      GetMultiplacerReleaseNotesPublishedApiArg
    >({
      query: () => ({ url: `/multiplacer/release-notes/published` }),
    }),
    getMultiplacerReleaseNotesDeployNotesUnpublished: build.query<
      GetMultiplacerReleaseNotesDeployNotesUnpublishedApiResponse,
      GetMultiplacerReleaseNotesDeployNotesUnpublishedApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/deploy-notes/unpublished`,
        params: {
          limit: queryArg.limit,
          cursor: queryArg.cursor,
          module: queryArg["module"],
        },
      }),
    }),
    postMultiplacerReleaseNotesPublish: build.mutation<
      PostMultiplacerReleaseNotesPublishApiResponse,
      PostMultiplacerReleaseNotesPublishApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/publish`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMedia:
      build.mutation<
        DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiResponse,
        DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiArg
      >({
        query: (queryArg) => ({
          url: `/multiplacer/release-notes/deploy-notes/${queryArg.deployNoteId}/change-items/${queryArg.changeItemId}/media`,
          method: "DELETE",
          params: {
            blobPath: queryArg.blobPath,
          },
        }),
      }),
    getMultiplacerReleaseNotesStatus: build.query<
      GetMultiplacerReleaseNotesStatusApiResponse,
      GetMultiplacerReleaseNotesStatusApiArg
    >({
      query: () => ({ url: `/multiplacer/release-notes/status` }),
    }),
    postMultiplacerReleaseNotesMarkSeen: build.mutation<
      PostMultiplacerReleaseNotesMarkSeenApiResponse,
      PostMultiplacerReleaseNotesMarkSeenApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/release-notes/mark-seen`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getRoutingGraphList: build.query<
      GetRoutingGraphListApiResponse,
      GetRoutingGraphListApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/list`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    postRoutingGraphSave: build.mutation<
      PostRoutingGraphSaveApiResponse,
      PostRoutingGraphSaveApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/save`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteRoutingGraphDelete: build.mutation<
      DeleteRoutingGraphDeleteApiResponse,
      DeleteRoutingGraphDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/routing/graph/delete`,
        method: "DELETE",
        params: {
          graphId: queryArg.graphId,
        },
      }),
    }),
    getMcappsProjectPns: build.query<
      GetMcappsProjectPnsApiResponse,
      GetMcappsProjectPnsApiArg
    >({
      query: (queryArg) => ({
        url: `/mcapps/project/pns`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postEarthingCalculate: build.mutation<
      PostEarthingCalculateApiResponse,
      PostEarthingCalculateApiArg
    >({
      query: (queryArg) => ({
        url: `/earthing/calculate`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getEarthingRuns: build.query<
      GetEarthingRunsApiResponse,
      GetEarthingRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/earthing/runs`,
        params: {
          limit: queryArg.limit,
        },
      }),
    }),
    postMultiplacerViews: build.mutation<
      PostMultiplacerViewsApiResponse,
      PostMultiplacerViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/views`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getMultiplacerViews: build.query<
      GetMultiplacerViewsApiResponse,
      GetMultiplacerViewsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/views`,
        params: {
          projectNo: queryArg.projectNo,
          scope: queryArg.scope,
        },
      }),
    }),
    getMultiplacerViewsByViewId: build.query<
      GetMultiplacerViewsByViewIdApiResponse,
      GetMultiplacerViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/views/${queryArg.viewId}`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    patchMultiplacerViewsByViewId: build.mutation<
      PatchMultiplacerViewsByViewIdApiResponse,
      PatchMultiplacerViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/views/${queryArg.viewId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    deleteMultiplacerViewsByViewId: build.mutation<
      DeleteMultiplacerViewsByViewIdApiResponse,
      DeleteMultiplacerViewsByViewIdApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/views/${queryArg.viewId}`,
        method: "DELETE",
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMultiplacerMigrationRunsAccess: build.query<
      GetMultiplacerMigrationRunsAccessApiResponse,
      GetMultiplacerMigrationRunsAccessApiArg
    >({
      query: () => ({ url: `/multiplacer/migration-runs/access` }),
    }),
    getMultiplacerMigrationRuns: build.query<
      GetMultiplacerMigrationRunsApiResponse,
      GetMultiplacerMigrationRunsApiArg
    >({
      query: () => ({ url: `/multiplacer/migration-runs` }),
    }),
    postMultiplacerMigrationRuns: build.mutation<
      PostMultiplacerMigrationRunsApiResponse,
      PostMultiplacerMigrationRunsApiArg
    >({
      query: (queryArg) => ({
        url: `/multiplacer/migration-runs`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as openapi };
export type PostMultiplacerArticlesByCompCodesApiResponse =
  /** status 200 Successful response */ {
    runId: string | null;
    articles: {
      projectNo: number;
      runId: string;
      capturedAt: string;
      compCode: string;
      name?: string | null;
      responsibility?: string | null;
      toBeDrawn?: boolean | null;
      properties?: {
        [key: string]: string | null;
      };
      source: {
        system: string;
        articleId?: (string | number) | null;
      };
    }[];
  };
export type PostMultiplacerArticlesByCompCodesApiArg = {
  body: {
    projectNo: number;
    compCodes: string[];
  };
};
export type GetMcbimSpacesApiResponse = /** status 200 Successful response */ {
  _id: string;
  building?: string;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  fileName: string;
  globalId: string;
  longName?: string;
  name: string;
  polygon?: number[][];
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
}[];
export type GetMcbimSpacesApiArg = {
  projectNo: number;
  jobId: string;
  floorGlobalId?: string;
};
export type GetMcbimSpacesInProjectApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerM: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAM: number;
        extentBM: number;
        extentCM: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId: string;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  }[];
export type GetMcbimSpacesInProjectApiArg = {
  projectNo: number;
  longName?: string;
};
export type GetMcbimItemApiResponse = /** status 200 Successful response */ {
  _id: string;
  globalId: string;
  buildingStory: {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
  } | null;
  instanceClass: string;
  expressId: number;
  predefinedType?: (string | number) | null;
  geometry?: {
    polygon2d?: number[][];
    bbox2d?: number[][];
    centerPoint2d?: number[];
    Obb3DWorldMmList?: {
      centerM: {
        x: number;
        y: number;
        z: number;
      };
      axisA: {
        x: number;
        y: number;
        z: number;
      };
      axisB: {
        x: number;
        y: number;
        z: number;
      };
      axisC: {
        x: number;
        y: number;
        z: number;
      };
      extentAM: number;
      extentBM: number;
      extentCM: number;
    }[];
    zWorldMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zWorldM?: {
      bottom: number;
      middle: number;
      top: number;
    };
    heightMm?: number;
    heightM?: number;
    floorZWorldMm?: number;
    floorZWorldM?: number;
    floorSource?: "buildingStorey" | "unknown";
    zRelMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zRelM?: {
      bottom: number;
      middle: number;
      top: number;
    };
  };
  geometryVersion?: number;
  fileAttr1?: string;
  fileAttr2?: string;
  fileAttr3?: string;
  fileAttr4?: string;
  fileFolderId?: string;
  fileIfcSchema: string;
  fileIsLatest: boolean;
  fileLastModifiedBy: string;
  fileName: string;
  filePath: string;
  fileStorageId: string;
  fileUploadedAt: string;
  includedMaterials?: {
    [key: string]: boolean;
  };
  insertedAt: string;
  longName?: string;
  materials?: {
    [key: string]: number;
  }[];
  name: string;
  description: string;
  building?: string;
  job: {
    jobId: string;
    createdAt: string;
  };
  bbox?: number[][];
  polygon?: number[][];
  centerPoint?: number[];
  psets: {
    [key: string]: {
      [key: string]: (string | number) | boolean;
    };
  };
  type: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  ceilingGrids?: {
    lines: number[][][];
    /** 3D point represented as [x, y, z] */
    intersectionPoint?: number[];
    /** 3D point represented as [x, y, z] */
    direction?: number[];
    tileSize?: number[];
    interiorLines?: number[][][];
    edgePolygon?: number[][];
    floorHeightMm?: number;
    floorHeightM?: number;
    worldHeightMm?: number;
    worldHeightM?: number;
  }[];
  error2d?: {
    message: string;
    stack: string;
  };
  geometryExtractedFromTypeGlobalId?: string;
  elementMaterials?: {
    name: string;
    thickness: number;
    calculatedVolume?: number;
  }[];
  primarySystem?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  } | null;
  systems?: {
    globalId: string;
    name: string;
    typeClass: string;
    predefinedType?: (string | number) | null;
  }[];
} | null;
export type GetMcbimItemApiArg = {
  projectNo: number;
  itemId: string;
};
export type GetMcbimItemsInSpaceApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerM: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAM: number;
        extentBM: number;
        extentCM: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId: string;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  }[];
export type GetMcbimItemsInSpaceApiArg = {
  spaceId?: string;
  spaceName?: string;
  projectNo: number;
};
export type GetMcbimFileFloorVersionsApiResponse =
  /** status 200 Successful response */ {
    building: string;
    buildingStoryName: string;
    buildingStoryGlobalId: string;
    jobId: string;
    createdAt: string;
    fileName: string;
  }[];
export type GetMcbimFileFloorVersionsApiArg = {
  projectNo: number;
};
export type GetMcbimFileFloorVersionsAllApiResponse =
  /** status 200 Successful response */ {
    building: string;
    buildingStoryName: string;
    buildingStoryGlobalId: string;
    jobId: string;
    createdAt: string;
    fileName: string;
    buildingStoryElevation?: number;
    instanceClasses: string[];
    itemCount: number;
    hasSpaces: boolean;
    nextBuildingStoryElevation?: number | null;
    floorHeightM?: number | null;
    floorHeightMm?: number | null;
  }[];
export type GetMcbimFileFloorVersionsAllApiArg = {
  projectNo: number;
};
export type GetMcbimSingleMcbimSpaceApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    globalId: string;
    buildingStory: {
      elevation?: number;
      expressId?: number;
      globalId: string;
      name: string;
    } | null;
    instanceClass: string;
    expressId: number;
    predefinedType?: (string | number) | null;
    geometry?: {
      polygon2d?: number[][];
      bbox2d?: number[][];
      centerPoint2d?: number[];
      Obb3DWorldMmList?: {
        centerM: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAM: number;
        extentBM: number;
        extentCM: number;
      }[];
      zWorldMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zWorldM?: {
        bottom: number;
        middle: number;
        top: number;
      };
      heightMm?: number;
      heightM?: number;
      floorZWorldMm?: number;
      floorZWorldM?: number;
      floorSource?: "buildingStorey" | "unknown";
      zRelMm?: {
        bottom: number;
        middle: number;
        top: number;
      };
      zRelM?: {
        bottom: number;
        middle: number;
        top: number;
      };
    };
    geometryVersion?: number;
    fileAttr1?: string;
    fileAttr2?: string;
    fileAttr3?: string;
    fileAttr4?: string;
    fileFolderId?: string;
    fileIfcSchema: string;
    fileIsLatest: boolean;
    fileLastModifiedBy: string;
    fileName: string;
    filePath: string;
    fileStorageId: string;
    fileUploadedAt: string;
    includedMaterials?: {
      [key: string]: boolean;
    };
    insertedAt: string;
    longName?: string;
    materials?: {
      [key: string]: number;
    }[];
    name: string;
    description: string;
    building?: string;
    job: {
      jobId: string;
      createdAt: string;
    };
    bbox?: number[][];
    polygon?: number[][];
    centerPoint?: number[];
    psets: {
      [key: string]: {
        [key: string]: (string | number) | boolean;
      };
    };
    type: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    error2d?: {
      message: string;
      stack: string;
    };
    geometryExtractedFromTypeGlobalId?: string;
    elementMaterials?: {
      name: string;
      thickness: number;
      calculatedVolume?: number;
    }[];
    primarySystem?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    } | null;
    systems?: {
      globalId: string;
      name: string;
      typeClass: string;
      predefinedType?: (string | number) | null;
    }[];
  } | null;
export type GetMcbimSingleMcbimSpaceApiArg = {
  projectNo: number;
  name: string;
};
export type PostMcbimItemsApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  longName?: string;
  globalId: string;
  fileName: string;
  polygon?: number[][];
  bbox?: number[][];
  instanceClass: string;
  centerPoint?: number[];
  geometry?: {
    polygon2d?: number[][];
    bbox2d?: number[][];
    centerPoint2d?: number[];
    Obb3DWorldMmList?: {
      centerM: {
        x: number;
        y: number;
        z: number;
      };
      axisA: {
        x: number;
        y: number;
        z: number;
      };
      axisB: {
        x: number;
        y: number;
        z: number;
      };
      axisC: {
        x: number;
        y: number;
        z: number;
      };
      extentAM: number;
      extentBM: number;
      extentCM: number;
    }[];
    zWorldMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zWorldM?: {
      bottom: number;
      middle: number;
      top: number;
    };
    heightMm?: number;
    heightM?: number;
    floorZWorldMm?: number;
    floorZWorldM?: number;
    floorSource?: "buildingStorey" | "unknown";
    zRelMm?: {
      bottom: number;
      middle: number;
      top: number;
    };
    zRelM?: {
      bottom: number;
      middle: number;
      top: number;
    };
  };
  coordinate?: number[];
  mmi?: string | null;
  compCode?: string | null;
  discipline?: string | null;
  system?: string | null;
  typeName?: string | null;
}[];
export type PostMcbimItemsApiArg = {
  body: {
    projectNo: number;
    buildingStoryName?: string;
    buildingStoryGlobalId?: string;
    fileName?: string;
    instanceClasses?: string[];
    disciplines?: string[];
    centerPointBounds?: {
      minX: number;
      maxX: number;
      minY: number;
      maxY: number;
    };
    includeGeometry?: boolean;
  };
};
export type GetMcbimBuildingStoriesApiResponse =
  /** status 200 Successful response */ {
    elevation?: number;
    expressId?: number;
    globalId: string;
    name: string;
    building?: string | null;
    spaceCount: number;
    job: {
      jobId: string;
      createdAt: string;
    };
  }[];
export type GetMcbimBuildingStoriesApiArg = {
  projectNo: number;
};
export type GetMcbimDisciplinesApiResponse =
  /** status 200 Successful response */ string[];
export type GetMcbimDisciplinesApiArg = {
  projectNo: number;
  buildingStoryName: string;
};
export type GetMcbimItemsUniqueClassesApiResponse =
  /** status 200 Successful response */ {
    instanceClasses: string[];
    typeClasses: string[];
    instanceClassCounts: {
      ifcClass: string;
      count: number;
    }[];
    typeClassCounts: {
      ifcClass: string;
      count: number;
    }[];
  };
export type GetMcbimItemsUniqueClassesApiArg = {
  projectNo: number;
  buildingStoryName: string;
};
export type GetMcbimCeilingLinesApiResponse =
  /** status 200 Successful response */ {
    [key: string]: number[][][];
  };
export type GetMcbimCeilingLinesApiArg = {
  projectNo: number;
  jobId: string;
  floorGlobalId?: string;
};
export type GetMcbimPipeSeriesApiResponse =
  /** status 200 Successful response */ {
    name: string;
    dimensions: number[];
  }[];
export type GetMcbimPipeSeriesApiArg = {
  projectNo: number;
};
export type GetMcbimFragsApiResponse = /** status 200 Successful response */ {
  projectNo: number;
  containerName: string;
  ttlMinutes: number;
  files: {
    fileName: string;
    frag: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
    manifest: {
      blobName: string;
      url: string;
      expiresAt: string;
      sizeBytes?: number;
    };
  }[];
};
export type GetMcbimFragsApiArg = {
  projectNo: number;
};
export type PostMcbimItems3DByIdsApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    globalId?: string;
    name?: string;
    instanceClass?: string;
    geometry?: {
      Obb3DWorldMmList?: {
        centerM: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAM: number;
        extentBM: number;
        extentCM: number;
      }[];
    };
  }[];
export type PostMcbimItems3DByIdsApiArg = {
  body: {
    projectNo: number;
    ids?: string[];
  };
};
export type PostMcbimItems3DNearCoordinateApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    globalId?: string;
    name?: string;
    instanceClass?: string;
    geometry?: {
      Obb3DWorldMmList?: {
        centerM: {
          x: number;
          y: number;
          z: number;
        };
        axisA: {
          x: number;
          y: number;
          z: number;
        };
        axisB: {
          x: number;
          y: number;
          z: number;
        };
        axisC: {
          x: number;
          y: number;
          z: number;
        };
        extentAM: number;
        extentBM: number;
        extentCM: number;
      }[];
    };
  }[];
export type PostMcbimItems3DNearCoordinateApiArg = {
  body: {
    projectNo: number;
    floorName: string;
    coordinate: number[];
    radiusMeters?: number;
  };
};
export type PostMultiplacerRoomsApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: "NRH" | "DRAMMEN_SYKEHUS";
          runBy: {
            _id: string;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id: string;
            name: string;
          };
          approvedAt: string;
        };
        evaluation?: {
          status:
            | "NOT_REVIEWED"
            | "CORRECT"
            | "INCORRECT"
            | "PARTLY_CORRECT"
            | "UNCLEAR";
          comment?: string;
          expectedValue?: string;
          reviewedBy?: {
            _id: string;
            name: string;
          };
          reviewedAt?: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id: string;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id: string;
            name: string;
          };
        };
        comments?: {
          _id: string;
          message: string;
          createdBy: {
            _id: string;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id: string;
          name: string;
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
        building?: string | null;
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            summary: {
              matchRatePct: number | null;
            };
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number | null;
            itemsTotal?: number;
            itemsIgnored?: number;
          };
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number | null;
                itemsTotal?: number;
                itemsIgnored?: number;
              };
            };
          } | null;
          perListType?: {
            [key: string]: {
              summary: {
                matchRatePct: number | null;
                itemsTotal?: number;
                itemsIgnored?: number;
              };
            };
          } | null;
        } | null;
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              updatedByUserName: string;
              updatedAt: string;
            };
          };
        };
      };
    };
  };
export type PostMultiplacerRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers?: string[];
    pns?: string[];
  };
};
export type GetMultiplacerSingleRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  } | null;
export type GetMultiplacerSingleRoomApiArg = {
  roomNumber: string;
  projectNo: number;
};
export type GetMultiplacerStandardRoomsApiResponse =
  /** status 200 Successful response */ string[];
export type GetMultiplacerStandardRoomsApiArg = {
  projectNo: number;
};
export type PostMultiplacerRoomsCeilingFreeTilesByFloorApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    floorName: string;
    roomCount: number;
    tileCount: number;
    rooms: {
      roomNumber: string;
      roomName?: string | null;
      floorName?: string | null;
      ceilingFreeTiles: {
        gridIndex: number;
        rowIndex: number;
        columnIndex: number;
        boundingBox: number[][];
      }[];
    }[];
  };
export type PostMultiplacerRoomsCeilingFreeTilesByFloorApiArg = {
  body: {
    projectNo: number;
    floorName: string;
  };
};
export type PutMultiplacerRoomLockApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PutMultiplacerRoomLockApiArg = {
  body: {
    roomNumber: string;
    lock: boolean;
    projectNo: number;
  };
};
export type PostMultiplacerRoomCeilingApiResponse =
  /** status 200 Successful response */ {
    matchedCount: number;
    modifiedCount: number;
    upsertedCount: number;
    upsertedIds: string[];
  };
export type PostMultiplacerRoomCeilingApiArg = {
  body: {
    projectNo: number;
    rooms: {
      roomNumber: string;
      ceilingCoordinate?: number[];
      ceilingDirection?: number[];
    }[];
  };
};
export type PostMultiplacerAirflowsImportApiResponse =
  /** status 200 Successful response */ {
    counts: {
      received: number;
      deduplicated: number;
      matched: number;
      updated: number;
      unchanged: number;
      unknown: number;
    };
    unknownRooms: string[];
  };
export type PostMultiplacerAirflowsImportApiArg = {
  body: {
    projectNo: number;
    items: {
      roomNumber: string;
      supplyAirFlow: number;
      returnAirFlow: number;
    }[];
    dryRun?: boolean;
    sourceFileName?: string;
    comment?: string;
  };
};
export type DeleteMultiplacerRoomValidationApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type DeleteMultiplacerRoomValidationApiArg = {
  projectNo: number;
};
export type PostMultiplacerRoomValidationDecisionStatusApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionStatusApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
    comment?: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentUpdateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
    message: string;
  };
};
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomValidationDecisionCommentDeleteApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    decisionKey: string;
    commentId: string;
  };
};
export type PostMultiplacerRoomCeilingCommentApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    message: string;
  };
};
export type PostMultiplacerRoomCeilingCommentUpdateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentUpdateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    commentId: string;
    message: string;
  };
};
export type PostMultiplacerRoomCeilingCommentDeleteApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomCeilingCommentDeleteApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    commentId: string;
  };
};
export type PostMultiplacerRoomSnapshotTrendByKeyApiResponse =
  /** status 200 Successful response */ {
    date: string;
    series: {
      value?: any;
      count: number;
    }[];
    total: number;
  }[];
export type PostMultiplacerRoomSnapshotTrendByKeyApiArg = {
  body: {
    projectNo: number;
    keyPath?: any;
    filter: {
      roomNumbers?: string[];
      pns?: string[];
      dateFrom: string;
      dateTo: string;
    };
    granularity?: "day" | "week" | "month";
    excludeEmptyString?: boolean;
    bucketConfig?:
      | {
          kind: "none";
        }
      | {
          kind: "ranges";
          ranges: {
            id: string;
            min: number;
            max: number;
          }[];
        };
  };
};
export type PostMultiplacerRoomsRoomNumberingCalculateNrhApiResponse =
  /** status 200 Successful response */ {
    roomNumberToCalculatedRoomNumber: {
      [key: string]: string;
    };
    heatmap: {
      edges: {
        id: string;
        points: (number[] | number[])[];
        color: number[];
        hasDistance: boolean;
      }[];
      nodes: {
        id: string;
        position: number[];
        color: number[];
        radiusM: number;
      }[];
    };
    updateResult: {
      counts: {
        received: number;
        matched: number;
        updated: number;
        unchanged: number;
        unknown: number;
      };
      unknownRooms: string[];
    };
  };
export type PostMultiplacerRoomsRoomNumberingCalculateNrhApiArg = {
  body: {
    projectNo: number;
    jobId: string;
    floorGlobalId: string;
    restrictionLines?: {
      start: number[];
      end: number[];
    }[];
    numberingOrigin?: number[] | null;
    selectedBuildings?: string[];
  };
};
export type GetMultiplacerRoomsRoomNumberingCalculationMetadataApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    jobId: string;
    floorGlobalId: string;
    floorName?: string;
    methodKey: "NRH" | "DRAMMEN_SYKEHUS";
    numberingOrigin: number[] | null;
    restrictionLines: {
      id?: string;
      start: number[];
      end: number[];
    }[];
    createdAt: string;
    updatedAt: string;
  } | null;
export type GetMultiplacerRoomsRoomNumberingCalculationMetadataApiArg = {
  projectNo: number;
  methodKey: "NRH" | "DRAMMEN_SYKEHUS";
  floorGlobalId: string;
};
export type PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiResponse =
  /** status 200 Successful response */ {
    counts: {
      received: number;
      matched: number;
      updated: number;
      unchanged: number;
      unknown: number;
    };
    unknownRooms: string[];
  };
export type PostMultiplacerRoomsUpdateCalculatedRoomNumbersApiArg = {
  body: {
    projectNo: number;
    methodKey: "NRH" | "DRAMMEN_SYKEHUS";
    roomNumberToCalculatedRoomNumber: {
      [key: string]: string;
    };
  };
};
export type PutMultiplacerRoomsRoomNumberingManualValueApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PutMultiplacerRoomsRoomNumberingManualValueApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    value: string;
  };
};
export type DeleteMultiplacerRoomsRoomNumberingManualValueApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type DeleteMultiplacerRoomsRoomNumberingManualValueApiArg = {
  projectNo: number;
  roomNumber: string;
};
export type PostMultiplacerRoomsRoomNumberingApprovalApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PostMultiplacerRoomsRoomNumberingApprovalApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
  };
};
export type DeleteMultiplacerRoomsRoomNumberingApprovalApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type DeleteMultiplacerRoomsRoomNumberingApprovalApiArg = {
  projectNo: number;
  roomNumber: string;
};
export type PostMultiplacerRoomsRoomNumberingApprovalBulkApiResponse =
  /** status 200 Successful response */ {
    counts: {
      requested: number;
      matched: number;
      updated: number;
      unknown: number;
      skippedMissingValue?: number;
    };
    unknownRooms: string[];
    rooms: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: "NRH" | "DRAMMEN_SYKEHUS";
          runBy: {
            _id: string;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id: string;
            name: string;
          };
          approvedAt: string;
        };
        evaluation?: {
          status:
            | "NOT_REVIEWED"
            | "CORRECT"
            | "INCORRECT"
            | "PARTLY_CORRECT"
            | "UNCLEAR";
          comment?: string;
          expectedValue?: string;
          reviewedBy?: {
            _id: string;
            name: string;
          };
          reviewedAt?: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id: string;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id: string;
            name: string;
          };
        };
        comments?: {
          _id: string;
          message: string;
          createdBy: {
            _id: string;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id: string;
          name: string;
        };
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            standardRoomId: string;
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            engineVersion?: string;
            sourceFingerprint?: string;
            validatedAt: string;
            validatedBy: string;
            note?: string;
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          ignoredComparison?: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
            reason: "PROJECT_IGNORED_COMPCODE";
          }[];
          appliedSettings?: {
            ignoredCompCodes: {
              compCode: string;
              description: string;
              addedBy: {
                userId: string;
                displayName: string;
              };
              addedAt: string;
            }[];
          };
          engineVersion?: string;
          sourceFingerprint?: string | null;
          validatedAt: string;
          validatedBy: string;
          note?: string | null;
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
              ignoredComparison?: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
                reason: "PROJECT_IGNORED_COMPCODE";
              }[];
            };
          };
          perListType?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
              ignoredComparison?: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
                reason: "PROJECT_IGNORED_COMPCODE";
              }[];
            };
          };
        };
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current?: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            } | null;
            history: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            }[];
            comments: {
              _id: string;
              message: string;
              createdBy: {
                _id: string;
                name: string;
              };
              createdAt: string;
              editedAt?: string | null;
              deletedAt?: string | null;
            }[];
          };
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
        building?: string | null;
      };
      mlPredictedDevices?: {
        deviceCategory:
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW";
        direction: number[];
        coordinate: number[];
      }[];
      mlPredictionMetadata?: {
        importedAt: string;
        generatedAt?: string | null;
        source: string;
        blobName: string;
      };
      existsInRfp?: boolean;
      existsInMcbim?: boolean;
      specifiedArticles?: {
        compCode: string;
        quantity: number;
        name?: string;
        responsibility?: string;
        category?: string;
        flags?: {
          toBeDrawn?: boolean;
          bip?: boolean;
        };
        sourceRef?: {
          system?: string;
          id?: string;
        };
      }[];
      specifiedArticlesSync?: {
        syncedAt: string;
        source?: string;
        version?: string;
      };
      polygonSnapshot?: {
        polygon: number[][];
        polygonHash: string;
      };
      ceilingGridIntersection?: {
        x: number;
        y: number;
        direction?: {
          x: number;
          y: number;
        };
      };
      ceilingFreeTiles?: {
        gridIndex: number;
        rowIndex: number;
        columnIndex: number;
        boundingBox: number[][];
      }[];
      mcbimItemsSnapshot?: {
        meta: {
          builtAt: string;
          runId: string;
          sourceKey: string;
        };
        items: {
          globalId: string;
          discipline?: string | null;
          system?: string | null;
          name?: string | null;
          typeName?: string | null;
          instanceClass: string;
          mmi?: string | null;
          compCode?: string | null;
          bboxSnapshot?: {
            bbox: number[][];
            bboxHash: string;
            hashVersion: 1;
          } | null;
          building?: string | null;
        }[];
      };
    }[];
  };
export type PostMultiplacerRoomsRoomNumberingApprovalBulkApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiResponse =
  /** status 200 Successful response */ {
    counts: {
      requested: number;
      matched: number;
      updated: number;
      unknown: number;
      skippedMissingValue?: number;
    };
    unknownRooms: string[];
    rooms: {
      _id: string;
      projectNo: number;
      roomNumber: string;
      roomNumbering?: {
        suggested?: string;
        run?: {
          methodKey: "NRH" | "DRAMMEN_SYKEHUS";
          runBy: {
            _id: string;
            name: string;
          };
          runAt: string;
        };
        value?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
        updatedAt?: string;
        approval?: {
          approvedBy: {
            _id: string;
            name: string;
          };
          approvedAt: string;
        };
        evaluation?: {
          status:
            | "NOT_REVIEWED"
            | "CORRECT"
            | "INCORRECT"
            | "PARTLY_CORRECT"
            | "UNCLEAR";
          comment?: string;
          expectedValue?: string;
          reviewedBy?: {
            _id: string;
            name: string;
          };
          reviewedAt?: string;
        };
      };
      roomName?: string;
      airFlow?: {
        selected?: {
          supply?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
          exhaust?: {
            value: number;
            source: "excel" | "manual";
            selectedAt?: string;
            selectedBy?: {
              _id: string;
              name: string;
            };
          };
        };
        excel?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          sourceRef?: {
            system?: string;
            id?: string;
            fileName?: string;
            importId?: string;
          };
          importedAt?: string;
          importedBy?: {
            _id: string;
            name: string;
          };
        };
        manual?: {
          supply?: number;
          exhaust?: number;
          comment?: string;
          updatedAt?: string;
          updatedBy?: {
            _id: string;
            name: string;
          };
        };
        comments?: {
          _id: string;
          message: string;
          createdBy: {
            _id: string;
            name: string;
          };
          createdAt: string;
          editedAt?: string | null;
          deletedAt?: string | null;
        }[];
      };
      ceilingComments: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
      supplyAirFlow?: number;
      returnAirFlow?: number;
      rfpStatus?: string | null;
      rfpMalRom?: string | null;
      drStatus?: string | null;
      designDeviationStatus?: string | null;
      updatedAt?: string;
      multiplacerCeilingDevicesLocked?: {
        bool: boolean;
        lockedAt?: string;
        createdBy?: {
          _id: string;
          name: string;
        };
      };
      validation?: {
        standardRoom?: {
          [key: string]: {
            standardRoomId: string;
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            engineVersion?: string;
            sourceFingerprint?: string;
            validatedAt: string;
            validatedBy: string;
            note?: string;
          };
        };
        specifiedArticles?: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          ignoredComparison?: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
            reason: "PROJECT_IGNORED_COMPCODE";
          }[];
          appliedSettings?: {
            ignoredCompCodes: {
              compCode: string;
              description: string;
              addedBy: {
                userId: string;
                displayName: string;
              };
              addedAt: string;
            }[];
          };
          engineVersion?: string;
          sourceFingerprint?: string | null;
          validatedAt: string;
          validatedBy: string;
          note?: string | null;
          perResponsibility?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
              ignoredComparison?: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
                reason: "PROJECT_IGNORED_COMPCODE";
              }[];
            };
          };
          perListType?: {
            [key: string]: {
              summary: {
                matchRatePct: number;
                itemsTotal: number;
                itemsMatched: number;
                itemsMissing: number;
                itemsExtra: number;
                status:
                  | "OK"
                  | "WARNING"
                  | "ERROR"
                  | "invalidGeometry"
                  | "noStandardRoom";
              };
              quantities?: {
                expectedQuantityTotal: number;
                observedQuantityTotal: number;
                quantityDeltaTotal: number;
              };
              comparison: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
              }[];
              ignoredComparison?: {
                compCode: string;
                label?: string | null;
                standardCount: number;
                instanceCount: number;
                delta: number;
                reason: "PROJECT_IGNORED_COMPCODE";
              }[];
            };
          };
        };
      };
      validationDecisions?: {
        standardRoom?: {
          [key: string]: {
            current?: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            } | null;
            history: {
              status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
              comment?: string | null;
              updatedByUserId: string;
              updatedByUserName: string;
              updatedAt: string;
            }[];
            comments: {
              _id: string;
              message: string;
              createdBy: {
                _id: string;
                name: string;
              };
              createdAt: string;
              editedAt?: string | null;
              deletedAt?: string | null;
            }[];
          };
        };
      };
      extraIfcInfo?: {
        pns?: string | null;
        floor?: string | null;
        mmi?: string | null;
        ceilingMmi?: string | null;
        building?: string | null;
      };
      mlPredictedDevices?: {
        deviceCategory:
          | "CHILLER_DEVICE"
          | "DEFAULT_DEVICE"
          | "DOOR"
          | "DOWN_LIGHT_DEVICE"
          | "FIRE_SUPPRESSION_DEVICE"
          | "FURNITURE"
          | "LIGHT_DEVICE_CIRCULAR"
          | "LIGHT_DEVICE"
          | "RETURN_AIR_DEVICE"
          | "SENSOR_DEVICE"
          | "SUPPLY_AIR_DEVICE"
          | "WINDOW";
        direction: number[];
        coordinate: number[];
      }[];
      mlPredictionMetadata?: {
        importedAt: string;
        generatedAt?: string | null;
        source: string;
        blobName: string;
      };
      existsInRfp?: boolean;
      existsInMcbim?: boolean;
      specifiedArticles?: {
        compCode: string;
        quantity: number;
        name?: string;
        responsibility?: string;
        category?: string;
        flags?: {
          toBeDrawn?: boolean;
          bip?: boolean;
        };
        sourceRef?: {
          system?: string;
          id?: string;
        };
      }[];
      specifiedArticlesSync?: {
        syncedAt: string;
        source?: string;
        version?: string;
      };
      polygonSnapshot?: {
        polygon: number[][];
        polygonHash: string;
      };
      ceilingGridIntersection?: {
        x: number;
        y: number;
        direction?: {
          x: number;
          y: number;
        };
      };
      ceilingFreeTiles?: {
        gridIndex: number;
        rowIndex: number;
        columnIndex: number;
        boundingBox: number[][];
      }[];
      mcbimItemsSnapshot?: {
        meta: {
          builtAt: string;
          runId: string;
          sourceKey: string;
        };
        items: {
          globalId: string;
          discipline?: string | null;
          system?: string | null;
          name?: string | null;
          typeName?: string | null;
          instanceClass: string;
          mmi?: string | null;
          compCode?: string | null;
          bboxSnapshot?: {
            bbox: number[][];
            bboxHash: string;
            hashVersion: 1;
          } | null;
          building?: string | null;
        }[];
      };
    }[];
  };
export type PostMultiplacerRoomsRoomNumberingApprovalBulkClearApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type PutMultiplacerRoomsRoomNumberingEvaluationApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  };
export type PutMultiplacerRoomsRoomNumberingEvaluationApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    status:
      | "NOT_REVIEWED"
      | "CORRECT"
      | "INCORRECT"
      | "PARTLY_CORRECT"
      | "UNCLEAR";
    comment?: string;
    expectedValue?: string;
  };
};
export type PostMultiplacerDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
export type PostMultiplacerDevicesApiArg = {
  body: {
    floor?: string;
    projectNo: number;
    roomNumbers?: string[];
  };
};
export type PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiResponse =
  /** status 200 Successful response */ {
    roomNumber: string;
    floor?: string;
    polygon: number[][];
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    ifcDeviceCount: number;
    similarityScore: number;
  }[];
export type PostMultiplacerDevicesSimilarRoomsWithIfcDesignApiArg = {
  body: {
    projectNo: number;
    roomName: string;
    roomNumber: string;
  };
};
export type PostMultiplacerDevicesSimilarRoomsWithDevicesApiResponse =
  /** status 200 Successful response */ {
    roomNumber: string;
    floor?: string;
    polygon: number[][];
    ceilingGrids?: {
      lines: number[][][];
      /** 3D point represented as [x, y, z] */
      intersectionPoint?: number[];
      /** 3D point represented as [x, y, z] */
      direction?: number[];
      tileSize?: number[];
      interiorLines?: number[][][];
      edgePolygon?: number[][];
      floorHeightMm?: number;
      floorHeightM?: number;
      worldHeightMm?: number;
      worldHeightM?: number;
    }[];
    locked?: boolean;
    lockedAt?: string;
    lockedBy?: {
      _id: string;
      name: string;
    };
    similarityScore: number;
  }[];
export type PostMultiplacerDevicesSimilarRoomsWithDevicesApiArg = {
  body: {
    projectNo: number;
    locked?: boolean | null;
    roomName: string;
    roomNumber: string;
  };
};
export type PutMultiplacerDeviceUpdateApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  };
export type PutMultiplacerDeviceUpdateApiArg = {
  body: {
    device: {
      _id: string;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    };
  };
};
export type PostMultiplacerDeviceAddDevicesApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
export type PostMultiplacerDeviceAddDevicesApiArg = {
  body: {
    devices: {
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  };
};
export type GetMultiplacerMediaAssetsApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    key: string;
    isProtected?: boolean | null;
    kind: "VIDEO" | "FILE";
    title: string;
    description?: string | null;
    blobPath: string;
    mimeType?: string | null;
    tags?: string[] | null;
    version?: string | null;
    visibility?: ("PUBLIC" | "AUTH" | null) | null;
    filename?: string | null;
    sizeBytes?: number | null;
    uploadedAt?: string | null;
    updatedAt?: string | null;
  }[];
export type GetMultiplacerMediaAssetsApiArg = void;
export type DeleteMultiplacerMediaAssetsByKeyApiResponse =
  /** status 200 Successful response */ {
    deletedFromBlob: boolean;
    removedFromDb: boolean;
  };
export type DeleteMultiplacerMediaAssetsByKeyApiArg = {
  key: string;
};
export type GetMultiplacerMediaAssetsMediaAssetKeyApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    key: string;
    isProtected?: boolean | null;
    kind: "VIDEO" | "FILE";
    title: string;
    description?: string | null;
    blobPath: string;
    mimeType?: string | null;
    tags?: string[] | null;
    version?: string | null;
    visibility?: ("PUBLIC" | "AUTH" | null) | null;
    filename?: string | null;
    sizeBytes?: number | null;
    uploadedAt?: string | null;
    updatedAt?: string | null;
  } | null;
export type GetMultiplacerMediaAssetsMediaAssetKeyApiArg = {
  mediaAssetKey:
    | "REVIT_DEMO"
    | "REVIT_PLUGIN_INSTALLER"
    | "FREETEXT_SEARCH"
    | "CEILING_MODULE"
    | "RFP_MODULE"
    | "EXPLORE_MODULE"
    | "COMPONENT"
    | "COLORFILTER";
};
export type PostMultiplacerDeviceDeleteInRoomsApiResponse =
  /** status 200 Successful response */ {
    deletedCount: number;
  };
export type PostMultiplacerDeviceDeleteInRoomsApiArg = {
  body: {
    projectNo: number;
    roomNumbers: string[];
  };
};
export type DeleteMultiplacerDeviceDeleteDeviceApiResponse =
  /** status 200 Successful response */ {
    acknowledged: boolean;
    deletedCount: number;
  };
export type DeleteMultiplacerDeviceDeleteDeviceApiArg = {
  deviceId: string;
};
export type GetAuthMeApiResponse = /** status 200 Successful response */ {
  _id: string;
  displayName: string;
  email?: string;
  isExternal?: boolean;
};
export type GetAuthMeApiArg = void;
export type GetAuthDevUsersApiResponse = /** status 200 Successful response */ {
  id: string;
  name: string;
  email: string;
}[];
export type GetAuthDevUsersApiArg = void;
export type GetAuthUsersByUserIdProfilePhotoApiResponse =
  /** status 200 Successful response */ {
    dataUrl: string | null;
  };
export type GetAuthUsersByUserIdProfilePhotoApiArg = {
  userId: string;
};
export type GetProjectSyncRunsApiResponse =
  /** status 200 Successful response */ {
    items: {
      roomSyncPlan?: {
        version: 1;
        mcbimRooms: true;
        mcbimItemsSnapshot: true;
        jobs: {
          drofusRooms: boolean;
          drofusSpecifiedArticles: boolean;
          deriveRoomExtraIfcInfo: boolean;
          validateSpecifiedArticles: boolean;
          standardRoomValidationDisciplines: string[];
          mlPredictCeilingDevices: boolean;
        };
        legacyNoopJobs: "addIfcInfo"[];
      };
      _id?: string;
      projectNo: number;
      type: "syncPipeline";
      trigger: "manual" | "scheduled" | "queue";
      requestedBy?: string | null;
      correlationId?: string | null;
      status: "running" | "succeeded" | "failed" | "canceled" | "queued";
      createdAt: string;
      startedAt?: string;
      finishedAt?: string;
      elapsedMs?: number;
      steps: {
        roomsSync?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            stats: {
              rfpFetched: number;
              rfpFetchFailed: boolean;
              ifcSpacesFetched: number;
              uniqueRoomNumbers: number;
              flagsResetRoomsMatched: number;
              upsertOps: number;
            };
          };
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        specifiedArticlesSync?: {
          status: ("running" | "succeeded" | "failed" | "pending") | "skipped";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            fetchedRows: number;
            uniqueRoomNumbers: number;
            resetMatchedRooms: number;
            bulkOps: number;
          };
          error?: {
            origin: string;
            code?: string | null;
            message?: string | null;
            stack?: string | null;
          } | null;
        };
        enqueueEnrich?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          jobTypes?: (
            | "specifiedArticles"
            | "mlPredictDevices"
            | "deriveRoomExtraIfcInfo"
            | "addIfcInfo"
            | string
          )[];
          queuedBatches?: number;
          totalRooms?: number;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        mcbimItemsSnapshot?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          result?: {
            totalExpected?: number;
            totalRooms?: number;
            ok?: number;
            skipped?: number;
            failed?: number;
            lastBatchMs?: number;
            avgMsPerRoom?: number;
            lastUpdatedAt?: string;
          };
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
        enrich?: {
          status:
            | "pending"
            | "running"
            | "succeeded"
            | "failed"
            | "skipped"
            | "queued";
          mlCeilingRoomNumbers?: string[];
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          total?: number;
          done?: number;
          failed?: number;
          lastUpdatedAt?: string;
          error?: {
            origin?: "upstream" | "config" | "network" | "db" | "unknown";
            code?: string | number;
            message: string;
            stack?: string;
          };
        };
      };
      meta?: {
        functionName?: string;
        invocationId?: string;
        hostInstanceId?: string;
        env?: string;
        version?: string;
      };
    }[];
    nextCursor?: string;
  };
export type GetProjectSyncRunsApiArg = {
  projectNo: number;
  limit?: number;
  cursor?: string;
};
export type GetMultiplacerAssetsSasApiResponse =
  /** status 200 Successful response */ {
    url: string;
    expiresAt: string;
  };
export type GetMultiplacerAssetsSasApiArg = {
  target: "release-notes" | "project-attachments" | "media-assets";
  blobPath: string;
};
export type GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse =
  /** status 200 Successful response */ {
    enabled: boolean;
    days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
    hour: number;
    minute: number;
    timezone: string;
    cronExpression: string;
    pageSize: number;
    maxRows: number | null;
    updatedAt?: string;
    lastTriggeredAt?: string;
    lastTriggeredSlot?: string;
  };
export type GetMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg = {
  projectNo: number;
};
export type PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiResponse =
  /** status 200 Successful response */ {
    enabled: boolean;
    days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
    hour: number;
    minute: number;
    timezone: string;
    cronExpression: string;
    pageSize: number;
    maxRows: number | null;
    updatedAt?: string;
    lastTriggeredAt?: string;
    lastTriggeredSlot?: string;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesSyncScheduleApiArg = {
  body: {
    projectNo: number;
    schedule: {
      enabled?: boolean;
      days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
      hour?: number;
      minute?: number;
      timezone?: string;
      pageSize?: number;
      maxRows?: number | null;
      lastTriggeredAt?: string;
      lastTriggeredSlot?: string;
    };
  };
};
export type GetMultiplacerDrofusInterfaceRunsApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      source: "drofus";
      entityType: "occurrence";
      status:
        | "queued"
        | "running"
        | "succeeded"
        | "test_completed"
        | "partial"
        | "dry_run_completed"
        | "failed"
        | "canceled";
      testMode?: boolean;
      trigger: "manual" | "scheduled" | "retry" | "backfill";
      startedAt: string;
      finishedAt?: string | null;
      elapsedMs?: number;
      previousRunId?: string | null;
      diffBaseRunId?: string | null;
      api: {
        baseUrl?: string;
        db?: string;
        project?: string;
        endpoint: "occurrences";
        select: string;
        selectHash: string;
        articleProperties?: {
          key: string;
          occurrenceField: string;
        }[];
        filter?: string | null;
        pageSize: number;
      };
      result?: {
        pageCount: number;
        fetchedRowCount: number;
        savedSnapshotCount?: number;
        articleSnapshotComplete?: boolean;
        interfaceRelevantCount?: number;
        addedCount?: number;
        updatedCount?: number;
        removedCount?: number;
        changeEventCount?: number;
        pageTimings?: {
          page: number;
          skip?: number | null;
          top?: number | null;
          fetchedRowCount: number;
          totalFetchedRowCount: number;
          savedSnapshotCount?: number;
          interfaceRelevantCount?: number;
          hasNext: boolean;
          fetchMs: number;
          jsonMs: number;
          processMs?: number;
          saveMs?: number;
          totalMs: number;
          capturedAt: string;
        }[];
      };
      error?: {
        origin?:
          | "upstream"
          | "config"
          | "network"
          | "db"
          | "validation"
          | "unknown";
        code?: string | number;
        message: string;
        stack?: string;
      };
      meta?: {
        functionName?: string;
        invocationId?: string;
        hostInstanceId?: string;
        schemaVersion: string;
        workerFunctionName?: string;
        workerInvocationId?: string;
        queuedAt?: string;
        maxRows?: number | null;
        pageSize?: number;
        currentSkip?: number | null;
        nextSkip?: number | null;
        lastPageAt?: string;
        repairedAt?: string;
        repairReason?: string;
        maxPages?: number | null;
        chunk?: {
          startedAt?: string;
          finishedAt?: string;
          elapsedMs?: number;
          pageCount?: number;
          startSkip?: number | null;
          nextSkip?: number | null;
          maxPages?: number | null;
        };
      };
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type GetMultiplacerDrofusInterfaceRunsApiArg = {
  limit?: number;
  offset?: number;
  projectNo: number;
  status?:
    | "queued"
    | "running"
    | "succeeded"
    | "test_completed"
    | "partial"
    | "dry_run_completed"
    | "failed"
    | "canceled";
};
export type PostMultiplacerDrofusInterfaceDeleteRunApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    runId: string;
    deletedRunCount: number;
    deletedSnapshotCount: number;
  };
export type PostMultiplacerDrofusInterfaceDeleteRunApiArg = {
  body: {
    projectNo: number;
    runId: string;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      runId: string;
      capturedAt: string;
      entityType: "occurrence";
      occurrenceId: number;
      stableKey: string;
      normalized: {
        occurrence: {
          id: number;
          quantity?: number | null;
          existingQuantity?: number | null;
          netQuantity?: number | null;
          classificationNumber?: string | null;
          runNo?: string | null;
          name?: string | null;
          comment?: string | null;
          responsibility?: string | null;
          overriddenResponsibility?: string | null;
          priority?: string | null;
          statusText?: string | null;
          refString?: string | null;
          extendedTfmId?: string | null;
          refCompOcc?: (string | number) | null;
          specialFunctionalRole?: string | null;
          mmiCode?: string | null;
          mmiIds?: number[] | null;
          programmedStatusIds?: number[] | null;
          isSubOccurrence?: boolean | null;
          subOccurrenceDepth?: number | null;
          hasIfcGuids?: boolean | null;
          ifcGuids?: (string[] | null) | (string | null);
        };
        room: {
          id?: number | null;
          functionNo?: string | null;
          architectNo?: string | null;
          fullName?: string | null;
          classification103Code?: string | null;
          classification109Code?: string | null;
        };
        article: {
          id?: number | null;
          compCode?: string | null;
          properties?: {
            [key: string]: string | null;
          };
          name?: string | null;
          responsibility?: string | null;
          toBeDrawn?: boolean | null;
          bip?: boolean | null;
        };
        system: {
          primarySystemId?: number | null;
          isSystemComponent?: boolean | null;
          isComponent?: boolean | null;
          hasSystems?: string | null;
          systemMembership?: string | null;
        };
        needs: {
          electrical: boolean;
          ikt: boolean;
          automation: boolean;
          vvs: boolean;
          normalPowerKw?: number | null;
          standbyPowerKw?: number | null;
          networkOutletCount?: number | null;
          sdConnection?: boolean | null;
          roomControl?: boolean | null;
          internalAutomation?: boolean | null;
          busCommunication?: boolean | null;
          vvsWater: boolean;
          vvsDrainage: boolean;
          vvsVentilation: boolean;
          vvsCooling: boolean;
          vvsHeatEmission: boolean;
          vvsTemperatureHumidity: boolean;
          medicalGas: boolean;
        };
        occurrenceData: {
          controlSystemType?: string | null;
          controlledBy?: string | null;
          globalId?: string | null;
          modelName?: string | null;
          refLocRoomServe?: string | null;
          statedVoltage?: string | null;
          statedFrequency?: string | null;
          statedPowerW?: number | null;
          statedAmpere?: number | null;
          fieldbus?: boolean | null;
          networkName?: string | null;
          macAddress?: string | null;
          ipAddress?: string | null;
        };
      };
      sourceValues?: {
        [key: string]: string | number | boolean | string[] | number[] | null;
      };
      contentHash: string;
      normalizedHash?: string;
      interfaceRelevant: boolean;
      interfaceRelevantReasons: string[];
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    runId: string;
    search?: string;
    pns?: string[];
    interfaceRelevant?: boolean;
    toBeDrawn?: boolean;
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    needs?: {
      electrical?: boolean;
      ikt?: boolean;
      automation?: boolean;
      vvs?: boolean;
    };
    sort?: {
      field?:
        | "occurrenceId"
        | "roomFunctionNo"
        | "roomArchitectNo"
        | "roomName"
        | "compCode"
        | "articleName"
        | "quantity"
        | "capturedAt";
      direction?: "asc" | "desc";
    };
  };
};
export type PostMultiplacerDrofusInterfaceRoomChangesApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      source: "drofus";
      entityType: "occurrence" | "room";
      runId: string;
      baseRunId: string;
      runStartedAt: string;
      runFinishedAt?: string | null;
      baseRunStartedAt?: string | null;
      entityId: string | number;
      stableKey: string;
      changeType: "added" | "removed" | "updated";
      changeKey: string;
      fieldId?: string;
      rawFieldId?: string;
      displayName?: string;
      group?:
        | "occurrence"
        | "room"
        | "article"
        | "system"
        | "tfmStatus"
        | "occurrenceData"
        | "articleNeeds"
        | "roomData"
        | "metadata";
      normalizedPath?: string;
      oldContentHash?: string;
      newContentHash?: string;
      oldNormalizedHash?: string;
      newNormalizedHash?: string;
      context: {
        occurrence?: {
          mmiCode?: string | null;
          mmiIds?: number[] | null;
          programmedStatusIds?: number[] | null;
        };
        room?: {
          id?: number | null;
          functionNo?: string | null;
          architectNo?: string | null;
          fullName?: string | null;
        };
        article?: {
          id?: number | null;
          compCode?: string | null;
          name?: string | null;
          responsibility?: string | null;
          toBeDrawn?: boolean | null;
        };
      };
      drofusLog?: {
        username?: string | null;
        time?: string | null;
        field?: string | null;
        action?: string | null;
        oldValue?: any;
        newValue?: any;
        note?: string | null;
        changeSource?: string | null;
        changeList?: string | null;
        confidence: "exact" | "probable" | "occurrence";
      };
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      severity: "low" | "medium" | "high";
      ruleId?: string;
      status: "open" | "acknowledged" | "closed";
      createdAt: string;
      acknowledgedAt?: string | null;
      acknowledgedBy?: string | null;
      closedAt?: string | null;
      closedBy?: string | null;
      meta?: {
        schemaVersion: string;
        selectHash?: string;
        diffAlgorithmVersion?: string;
      };
      oldValue?: any;
      newValue?: any;
      roomBuilding?: string | null;
      roomFloor?: string | null;
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceRoomChangesApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    roomFunctionNumbers: string[];
    dateFrom: string;
    dateTo: string;
  };
};
export type PostMultiplacerDrofusInterfaceProjectChangeEventsApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: string;
      projectNo: number;
      source: "drofus";
      entityType: "occurrence" | "room";
      runId: string;
      baseRunId: string;
      runStartedAt: string;
      runFinishedAt?: string | null;
      baseRunStartedAt?: string | null;
      entityId: string | number;
      stableKey: string;
      changeType: "added" | "removed" | "updated";
      changeKey: string;
      fieldId?: string;
      rawFieldId?: string;
      displayName?: string;
      group?:
        | "occurrence"
        | "room"
        | "article"
        | "system"
        | "tfmStatus"
        | "occurrenceData"
        | "articleNeeds"
        | "roomData"
        | "metadata";
      normalizedPath?: string;
      oldContentHash?: string;
      newContentHash?: string;
      oldNormalizedHash?: string;
      newNormalizedHash?: string;
      context: {
        occurrence?: {
          mmiCode?: string | null;
          mmiIds?: number[] | null;
          programmedStatusIds?: number[] | null;
        };
        room?: {
          id?: number | null;
          functionNo?: string | null;
          architectNo?: string | null;
          fullName?: string | null;
        };
        article?: {
          id?: number | null;
          compCode?: string | null;
          name?: string | null;
          responsibility?: string | null;
          toBeDrawn?: boolean | null;
        };
      };
      drofusLog?: {
        username?: string | null;
        time?: string | null;
        field?: string | null;
        action?: string | null;
        oldValue?: any;
        newValue?: any;
        note?: string | null;
        changeSource?: string | null;
        changeList?: string | null;
        confidence: "exact" | "probable" | "occurrence";
      };
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      severity: "low" | "medium" | "high";
      ruleId?: string;
      status: "open" | "acknowledged" | "closed";
      createdAt: string;
      acknowledgedAt?: string | null;
      acknowledgedBy?: string | null;
      closedAt?: string | null;
      closedBy?: string | null;
      meta?: {
        schemaVersion: string;
        selectHash?: string;
        diffAlgorithmVersion?: string;
      };
      oldValue?: any;
      newValue?: any;
      roomBuilding?: string | null;
      roomFloor?: string | null;
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceProjectChangeEventsApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    includeSynchronizationChanges?: boolean;
    search?: string;
    pns?: string[];
    roomFunctionNo?: string | null;
    roomFunctionNumbers?: string[];
    dateFrom?: string;
    dateTo?: string;
    changeTypes?: ("added" | "removed" | "updated")[];
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    attributeKeys?: string[];
    mmiCodes?: string[];
    statuses?: ("open" | "acknowledged" | "closed")[];
    severities?: ("low" | "medium" | "high")[];
    sort?: {
      field?:
        | "runStartedAt"
        | "createdAt"
        | "changeType"
        | "status"
        | "severity"
        | "roomFunctionNo"
        | "roomName"
        | "compCode"
        | "articleName"
        | "field";
      direction?: "asc" | "desc";
    };
  };
};
export type PostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsApiResponse =
  /** status 200 Successful response */ {
    items: {
      displayName?: string | null;
      key: string;
      count: number;
    }[];
  };
export type PostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsApiArg =
  {
    body: {
      projectNo: number;
      includeSynchronizationChanges?: boolean;
      search?: string;
      pns?: string[];
      roomFunctionNo?: string | null;
      roomFunctionNumbers?: string[];
      dateFrom?: string;
      dateTo?: string;
      changeTypes?: ("added" | "removed" | "updated")[];
      affectedDisciplines?: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      mmiCodes?: string[];
      statuses?: ("open" | "acknowledged" | "closed")[];
      severities?: ("low" | "medium" | "high")[];
    };
  };
export type PostMultiplacerDrofusInterfaceProjectChangeEventMmiOptionsApiResponse =
  /** status 200 Successful response */ {
    items: string[];
  };
export type PostMultiplacerDrofusInterfaceProjectChangeEventMmiOptionsApiArg = {
  body: {
    projectNo: number;
  };
};
export type PostMultiplacerDrofusInterfaceProjectChangeEventsByRoomApiResponse =
  /** status 200 Successful response */ {
    items: {
      roomFunctionNo: string | null;
      roomName: string | null;
      roomArchitectNo: string | null;
      roomBuilding: string | null;
      roomFloor: string | null;
      latestRunStartedAt?: any | null;
      changeCount: number;
      addedCount: number;
      removedCount: number;
      updatedCount: number;
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      changes: {
        _id?: string;
        projectNo: number;
        source: "drofus";
        entityType: "occurrence" | "room";
        runId: string;
        baseRunId: string;
        runStartedAt: string;
        runFinishedAt?: string | null;
        baseRunStartedAt?: string | null;
        entityId: string | number;
        stableKey: string;
        changeType: "added" | "removed" | "updated";
        changeKey: string;
        fieldId?: string;
        rawFieldId?: string;
        displayName?: string;
        group?:
          | "occurrence"
          | "room"
          | "article"
          | "system"
          | "tfmStatus"
          | "occurrenceData"
          | "articleNeeds"
          | "roomData"
          | "metadata";
        normalizedPath?: string;
        oldContentHash?: string;
        newContentHash?: string;
        oldNormalizedHash?: string;
        newNormalizedHash?: string;
        context: {
          occurrence?: {
            mmiCode?: string | null;
            mmiIds?: number[] | null;
            programmedStatusIds?: number[] | null;
          };
          room?: {
            id?: number | null;
            functionNo?: string | null;
            architectNo?: string | null;
            fullName?: string | null;
          };
          article?: {
            id?: number | null;
            compCode?: string | null;
            name?: string | null;
            responsibility?: string | null;
            toBeDrawn?: boolean | null;
          };
        };
        drofusLog?: {
          username?: string | null;
          time?: string | null;
          field?: string | null;
          action?: string | null;
          oldValue?: any;
          newValue?: any;
          note?: string | null;
          changeSource?: string | null;
          changeList?: string | null;
          confidence: "exact" | "probable" | "occurrence";
        };
        affectedDisciplines: (
          | "RIV"
          | "RIE"
          | "RIAut"
          | "RIKT"
          | "ARK"
          | "IARK"
          | "RKJ"
          | "RUT"
          | "HF"
          | "UNKNOWN"
        )[];
        severity: "low" | "medium" | "high";
        ruleId?: string;
        status: "open" | "acknowledged" | "closed";
        createdAt: string;
        acknowledgedAt?: string | null;
        acknowledgedBy?: string | null;
        closedAt?: string | null;
        closedBy?: string | null;
        meta?: {
          schemaVersion: string;
          selectHash?: string;
          diffAlgorithmVersion?: string;
        };
        oldValue?: any;
        newValue?: any;
        roomBuilding?: string | null;
        roomFloor?: string | null;
      }[];
    }[];
    total: number;
  };
export type PostMultiplacerDrofusInterfaceProjectChangeEventsByRoomApiArg = {
  body: {
    projectNo: number;
    includeSynchronizationChanges?: boolean;
    search?: string;
    pns?: string[];
    roomFunctionNumbers?: string[];
    dateFrom?: string;
    dateTo?: string;
    changeTypes?: ("added" | "removed" | "updated")[];
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    attributeKeys?: string[];
    mmiCodes?: string[];
    statuses?: ("open" | "acknowledged" | "closed")[];
    severities?: ("low" | "medium" | "high")[];
  };
};
export type PostMultiplacerDrofusInterfaceArticlesApiResponse =
  /** status 200 Successful response */ {
    items: {
      articleId: number | null;
      compCode: string | null;
      articleName: string | null;
      articleResponsibility?: string | null;
      toBeDrawn?: boolean | null;
      bip?: boolean | null;
      occurrenceCount: number;
      uniqueRoomCount: number;
      totalQuantity: number;
      affectedDisciplines: (
        | "RIV"
        | "RIE"
        | "RIAut"
        | "RIKT"
        | "ARK"
        | "IARK"
        | "RKJ"
        | "RUT"
        | "HF"
        | "UNKNOWN"
      )[];
      interfaceRelevantCount: number;
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
      };
    }[];
    total: number;
    limit: number;
    offset: number;
    hasMore: boolean;
  };
export type PostMultiplacerDrofusInterfaceArticlesApiArg = {
  body: {
    limit?: number;
    offset?: number;
    projectNo: number;
    runId: string;
    search?: string;
    pns?: string[];
    interfaceRelevant?: boolean;
    toBeDrawn?: boolean;
    affectedDisciplines?: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    needs?: {
      electrical?: boolean;
      ikt?: boolean;
      automation?: boolean;
      vvs?: boolean;
    };
    sort?: {
      field?:
        | "articleId"
        | "compCode"
        | "articleName"
        | "occurrenceCount"
        | "uniqueRoomCount"
        | "totalQuantity";
      direction?: "asc" | "desc";
    };
  };
};
export type PostMultiplacerDrofusInterfaceOccurrenceApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    projectNo: number;
    runId: string;
    capturedAt: string;
    entityType: "occurrence";
    occurrenceId: number;
    stableKey: string;
    normalized: {
      occurrence: {
        id: number;
        quantity?: number | null;
        existingQuantity?: number | null;
        netQuantity?: number | null;
        classificationNumber?: string | null;
        runNo?: string | null;
        name?: string | null;
        comment?: string | null;
        responsibility?: string | null;
        overriddenResponsibility?: string | null;
        priority?: string | null;
        statusText?: string | null;
        refString?: string | null;
        extendedTfmId?: string | null;
        refCompOcc?: (string | number) | null;
        specialFunctionalRole?: string | null;
        mmiCode?: string | null;
        mmiIds?: number[] | null;
        programmedStatusIds?: number[] | null;
        isSubOccurrence?: boolean | null;
        subOccurrenceDepth?: number | null;
        hasIfcGuids?: boolean | null;
        ifcGuids?: (string[] | null) | (string | null);
      };
      room: {
        id?: number | null;
        functionNo?: string | null;
        architectNo?: string | null;
        fullName?: string | null;
        classification103Code?: string | null;
        classification109Code?: string | null;
      };
      article: {
        id?: number | null;
        compCode?: string | null;
        properties?: {
          [key: string]: string | null;
        };
        name?: string | null;
        responsibility?: string | null;
        toBeDrawn?: boolean | null;
        bip?: boolean | null;
      };
      system: {
        primarySystemId?: number | null;
        isSystemComponent?: boolean | null;
        isComponent?: boolean | null;
        hasSystems?: string | null;
        systemMembership?: string | null;
      };
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
        normalPowerKw?: number | null;
        standbyPowerKw?: number | null;
        networkOutletCount?: number | null;
        sdConnection?: boolean | null;
        roomControl?: boolean | null;
        internalAutomation?: boolean | null;
        busCommunication?: boolean | null;
        vvsWater: boolean;
        vvsDrainage: boolean;
        vvsVentilation: boolean;
        vvsCooling: boolean;
        vvsHeatEmission: boolean;
        vvsTemperatureHumidity: boolean;
        medicalGas: boolean;
      };
      occurrenceData: {
        controlSystemType?: string | null;
        controlledBy?: string | null;
        globalId?: string | null;
        modelName?: string | null;
        refLocRoomServe?: string | null;
        statedVoltage?: string | null;
        statedFrequency?: string | null;
        statedPowerW?: number | null;
        statedAmpere?: number | null;
        fieldbus?: boolean | null;
        networkName?: string | null;
        macAddress?: string | null;
        ipAddress?: string | null;
      };
    };
    sourceValues?: {
      [key: string]: string | number | boolean | string[] | number[] | null;
    };
    contentHash: string;
    normalizedHash?: string;
    interfaceRelevant: boolean;
    interfaceRelevantReasons: string[];
    affectedDisciplines: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
  };
export type PostMultiplacerDrofusInterfaceOccurrenceApiArg = {
  body: {
    projectNo: number;
    runId?: string | any;
    occurrenceId: number;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrenceByIfcGuidApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    projectNo: number;
    runId: string;
    capturedAt: string;
    entityType: "occurrence";
    occurrenceId: number;
    stableKey: string;
    normalized: {
      occurrence: {
        id: number;
        quantity?: number | null;
        existingQuantity?: number | null;
        netQuantity?: number | null;
        classificationNumber?: string | null;
        runNo?: string | null;
        name?: string | null;
        comment?: string | null;
        responsibility?: string | null;
        overriddenResponsibility?: string | null;
        priority?: string | null;
        statusText?: string | null;
        refString?: string | null;
        extendedTfmId?: string | null;
        refCompOcc?: (string | number) | null;
        specialFunctionalRole?: string | null;
        mmiCode?: string | null;
        mmiIds?: number[] | null;
        programmedStatusIds?: number[] | null;
        isSubOccurrence?: boolean | null;
        subOccurrenceDepth?: number | null;
        hasIfcGuids?: boolean | null;
        ifcGuids?: (string[] | null) | (string | null);
      };
      room: {
        id?: number | null;
        functionNo?: string | null;
        architectNo?: string | null;
        fullName?: string | null;
        classification103Code?: string | null;
        classification109Code?: string | null;
      };
      article: {
        id?: number | null;
        compCode?: string | null;
        properties?: {
          [key: string]: string | null;
        };
        name?: string | null;
        responsibility?: string | null;
        toBeDrawn?: boolean | null;
        bip?: boolean | null;
      };
      system: {
        primarySystemId?: number | null;
        isSystemComponent?: boolean | null;
        isComponent?: boolean | null;
        hasSystems?: string | null;
        systemMembership?: string | null;
      };
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
        normalPowerKw?: number | null;
        standbyPowerKw?: number | null;
        networkOutletCount?: number | null;
        sdConnection?: boolean | null;
        roomControl?: boolean | null;
        internalAutomation?: boolean | null;
        busCommunication?: boolean | null;
        vvsWater: boolean;
        vvsDrainage: boolean;
        vvsVentilation: boolean;
        vvsCooling: boolean;
        vvsHeatEmission: boolean;
        vvsTemperatureHumidity: boolean;
        medicalGas: boolean;
      };
      occurrenceData: {
        controlSystemType?: string | null;
        controlledBy?: string | null;
        globalId?: string | null;
        modelName?: string | null;
        refLocRoomServe?: string | null;
        statedVoltage?: string | null;
        statedFrequency?: string | null;
        statedPowerW?: number | null;
        statedAmpere?: number | null;
        fieldbus?: boolean | null;
        networkName?: string | null;
        macAddress?: string | null;
        ipAddress?: string | null;
      };
    };
    sourceValues?: {
      [key: string]: string | number | boolean | string[] | number[] | null;
    };
    contentHash: string;
    normalizedHash?: string;
    interfaceRelevant: boolean;
    interfaceRelevantReasons: string[];
    affectedDisciplines: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
  } | null;
export type PostMultiplacerDrofusInterfaceOccurrenceByIfcGuidApiArg = {
  body: {
    projectNo: number;
    ifcGuid: string;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesInRoomApiResponse =
  /** status 200 Successful response */ {
    _id?: string;
    projectNo: number;
    runId: string;
    capturedAt: string;
    entityType: "occurrence";
    occurrenceId: number;
    stableKey: string;
    normalized: {
      occurrence: {
        id: number;
        quantity?: number | null;
        existingQuantity?: number | null;
        netQuantity?: number | null;
        classificationNumber?: string | null;
        runNo?: string | null;
        name?: string | null;
        comment?: string | null;
        responsibility?: string | null;
        overriddenResponsibility?: string | null;
        priority?: string | null;
        statusText?: string | null;
        refString?: string | null;
        extendedTfmId?: string | null;
        refCompOcc?: (string | number) | null;
        specialFunctionalRole?: string | null;
        mmiCode?: string | null;
        mmiIds?: number[] | null;
        programmedStatusIds?: number[] | null;
        isSubOccurrence?: boolean | null;
        subOccurrenceDepth?: number | null;
        hasIfcGuids?: boolean | null;
        ifcGuids?: (string[] | null) | (string | null);
      };
      room: {
        id?: number | null;
        functionNo?: string | null;
        architectNo?: string | null;
        fullName?: string | null;
        classification103Code?: string | null;
        classification109Code?: string | null;
      };
      article: {
        id?: number | null;
        compCode?: string | null;
        properties?: {
          [key: string]: string | null;
        };
        name?: string | null;
        responsibility?: string | null;
        toBeDrawn?: boolean | null;
        bip?: boolean | null;
      };
      system: {
        primarySystemId?: number | null;
        isSystemComponent?: boolean | null;
        isComponent?: boolean | null;
        hasSystems?: string | null;
        systemMembership?: string | null;
      };
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
        normalPowerKw?: number | null;
        standbyPowerKw?: number | null;
        networkOutletCount?: number | null;
        sdConnection?: boolean | null;
        roomControl?: boolean | null;
        internalAutomation?: boolean | null;
        busCommunication?: boolean | null;
        vvsWater: boolean;
        vvsDrainage: boolean;
        vvsVentilation: boolean;
        vvsCooling: boolean;
        vvsHeatEmission: boolean;
        vvsTemperatureHumidity: boolean;
        medicalGas: boolean;
      };
      occurrenceData: {
        controlSystemType?: string | null;
        controlledBy?: string | null;
        globalId?: string | null;
        modelName?: string | null;
        refLocRoomServe?: string | null;
        statedVoltage?: string | null;
        statedFrequency?: string | null;
        statedPowerW?: number | null;
        statedAmpere?: number | null;
        fieldbus?: boolean | null;
        networkName?: string | null;
        macAddress?: string | null;
        ipAddress?: string | null;
      };
    };
    sourceValues?: {
      [key: string]: string | number | boolean | string[] | number[] | null;
    };
    contentHash: string;
    normalizedHash?: string;
    interfaceRelevant: boolean;
    interfaceRelevantReasons: string[];
    affectedDisciplines: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
  }[];
export type PostMultiplacerDrofusInterfaceOccurrencesInRoomApiArg = {
  body: {
    projectNo: number;
    roomFunctionNo: string;
  };
};
export type PostTdroomUpsertApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  } | null;
export type PostTdroomUpsertApiArg = {
  body: {
    _id?: string | any;
    projectNo: number;
    roomNumber: string;
    roomLongName: string;
    area: number;
    polygon: number[][];
    devices: {
      _id?: any;
      boundingBox?: number[][];
      compCode: string;
      coordinate: number[];
      createdAt?: string;
      description: string;
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction?: number[];
      discipline:
        | "VENTILATION"
        | "ELECTRICAL"
        | "SPRINKLER"
        | "ARCHITECTURE"
        | "UNKNOWN";
      floor: string;
      grid?: any;
      pns?: string;
      productName?: string;
      projectNo: string;
      returnAirFlow?: number;
      roomName?: string;
      roomNumber: string;
      supplyAirFlow?: number;
      tileSize?: number[];
      updatedAt?: string;
      bottomEdgeHeightAboveFloorMm: number;
      bottomEdgeHeightAboveFloorM?: number;
    }[];
  };
};
export type GetTdroomSingleApiResponse = /** status 200 Successful response */ {
  _id: string;
  projectNo: number;
  roomNumber: string;
  roomLongName: string;
  area: number;
  polygon: number[][];
  devices: {
    _id?: any;
    boundingBox?: number[][];
    compCode: string;
    coordinate: number[];
    createdAt?: string;
    description: string;
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction?: number[];
    discipline:
      | "VENTILATION"
      | "ELECTRICAL"
      | "SPRINKLER"
      | "ARCHITECTURE"
      | "UNKNOWN";
    floor: string;
    grid?: any;
    pns?: string;
    productName?: string;
    projectNo: string;
    returnAirFlow?: number;
    roomName?: string;
    roomNumber: string;
    supplyAirFlow?: number;
    tileSize?: number[];
    updatedAt?: string;
    bottomEdgeHeightAboveFloorMm: number;
    bottomEdgeHeightAboveFloorM?: number;
  }[];
} | null;
export type GetTdroomSingleApiArg = {
  tdroomId: string;
};
export type GetTdroomAllApiResponse = /** status 200 Successful response */ {
  _id: string;
  roomLongName: string;
  roomNumber: string;
  projectNo: number;
}[];
export type GetTdroomAllApiArg = void;
export type PostAddProjectTdRoomsApiResponse =
  /** status 200 Successful response */ {
    nrOfRoomsAdded: number;
  };
export type PostAddProjectTdRoomsApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id: string;
      globalId: string;
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      instanceClass: string;
      expressId: number;
      predefinedType?: (string | number) | null;
      geometry?: {
        polygon2d?: number[][];
        bbox2d?: number[][];
        centerPoint2d?: number[];
        Obb3DWorldMmList?: {
          centerM: {
            x: number;
            y: number;
            z: number;
          };
          axisA: {
            x: number;
            y: number;
            z: number;
          };
          axisB: {
            x: number;
            y: number;
            z: number;
          };
          axisC: {
            x: number;
            y: number;
            z: number;
          };
          extentAM: number;
          extentBM: number;
          extentCM: number;
        }[];
        zWorldMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zWorldM?: {
          bottom: number;
          middle: number;
          top: number;
        };
        heightMm?: number;
        heightM?: number;
        floorZWorldMm?: number;
        floorZWorldM?: number;
        floorSource?: "buildingStorey" | "unknown";
        zRelMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zRelM?: {
          bottom: number;
          middle: number;
          top: number;
        };
      };
      geometryVersion?: number;
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileFolderId?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      description: string;
      building?: string;
      job: {
        jobId: string;
        createdAt: string;
      };
      bbox?: number[][];
      polygon?: number[][];
      centerPoint?: number[];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      ceilingGrids?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
        tileSize?: number[];
        interiorLines?: number[][][];
        edgePolygon?: number[][];
        floorHeightMm?: number;
        floorHeightM?: number;
        worldHeightMm?: number;
        worldHeightM?: number;
      }[];
      error2d?: {
        message: string;
        stack: string;
      };
      geometryExtractedFromTypeGlobalId?: string;
      elementMaterials?: {
        name: string;
        thickness: number;
        calculatedVolume?: number;
      }[];
      primarySystem?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      systems?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      }[];
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type GetMultiplacerDevicetypesApiArg = {
  projectNo: number;
};
export type PostMultiplacerDevicetypesAggregateApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    instanceClass:
      | "IfcAirTerminal"
      | "IfcLightFixture"
      | "IfcFireSuppressionTerminal"
      | "IfcSensor"
      | "IfcChiller";
    compCode: string | null;
    typeName: string;
    boundingBox: number[][];
    firstDocument: {
      _id: string;
      globalId: string;
      buildingStory: {
        elevation?: number;
        expressId?: number;
        globalId: string;
        name: string;
      } | null;
      instanceClass: string;
      expressId: number;
      predefinedType?: (string | number) | null;
      geometry?: {
        polygon2d?: number[][];
        bbox2d?: number[][];
        centerPoint2d?: number[];
        Obb3DWorldMmList?: {
          centerM: {
            x: number;
            y: number;
            z: number;
          };
          axisA: {
            x: number;
            y: number;
            z: number;
          };
          axisB: {
            x: number;
            y: number;
            z: number;
          };
          axisC: {
            x: number;
            y: number;
            z: number;
          };
          extentAM: number;
          extentBM: number;
          extentCM: number;
        }[];
        zWorldMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zWorldM?: {
          bottom: number;
          middle: number;
          top: number;
        };
        heightMm?: number;
        heightM?: number;
        floorZWorldMm?: number;
        floorZWorldM?: number;
        floorSource?: "buildingStorey" | "unknown";
        zRelMm?: {
          bottom: number;
          middle: number;
          top: number;
        };
        zRelM?: {
          bottom: number;
          middle: number;
          top: number;
        };
      };
      geometryVersion?: number;
      fileAttr1?: string;
      fileAttr2?: string;
      fileAttr3?: string;
      fileAttr4?: string;
      fileFolderId?: string;
      fileIfcSchema: string;
      fileIsLatest: boolean;
      fileLastModifiedBy: string;
      fileName: string;
      filePath: string;
      fileStorageId: string;
      fileUploadedAt: string;
      includedMaterials?: {
        [key: string]: boolean;
      };
      insertedAt: string;
      longName?: string;
      materials?: {
        [key: string]: number;
      }[];
      name: string;
      description: string;
      building?: string;
      job: {
        jobId: string;
        createdAt: string;
      };
      bbox?: number[][];
      polygon?: number[][];
      centerPoint?: number[];
      psets: {
        [key: string]: {
          [key: string]: (string | number) | boolean;
        };
      };
      type: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      ceilingGrids?: {
        lines: number[][][];
        /** 3D point represented as [x, y, z] */
        intersectionPoint?: number[];
        /** 3D point represented as [x, y, z] */
        direction?: number[];
        tileSize?: number[];
        interiorLines?: number[][][];
        edgePolygon?: number[][];
        floorHeightMm?: number;
        floorHeightM?: number;
        worldHeightMm?: number;
        worldHeightM?: number;
      }[];
      error2d?: {
        message: string;
        stack: string;
      };
      geometryExtractedFromTypeGlobalId?: string;
      elementMaterials?: {
        name: string;
        thickness: number;
        calculatedVolume?: number;
      }[];
      primarySystem?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      } | null;
      systems?: {
        globalId: string;
        name: string;
        typeClass: string;
        predefinedType?: (string | number) | null;
      }[];
    };
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
  }[];
export type PostMultiplacerDevicetypesAggregateApiArg = {
  body: {
    projectNo: number;
  };
};
export type GetMultiplacerDevicetypesStatsApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    total: number;
    categories: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      count: number;
    }[];
  };
export type GetMultiplacerDevicetypesStatsApiArg = {
  projectNo: number;
};
export type PostMlPredictCeilingDevicesApiResponse =
  /** status 200 Successful response */ {
    deviceCategory:
      | "CHILLER_DEVICE"
      | "DEFAULT_DEVICE"
      | "DOOR"
      | "DOWN_LIGHT_DEVICE"
      | "FIRE_SUPPRESSION_DEVICE"
      | "FURNITURE"
      | "LIGHT_DEVICE_CIRCULAR"
      | "LIGHT_DEVICE"
      | "RETURN_AIR_DEVICE"
      | "SENSOR_DEVICE"
      | "SUPPLY_AIR_DEVICE"
      | "WINDOW";
    direction: number[];
    coordinate: number[];
  }[];
export type PostMlPredictCeilingDevicesApiArg = {
  body: {
    roomNr: string;
    projectNo: number;
    ceilingGridIntersection: {
      x: number;
      y: number;
      direction: {
        x: number;
        y: number;
      };
    };
  };
};
export type GetMlPingApiResponse = /** status 200 Successful response */ {
  message: string;
};
export type GetMlPingApiArg = void;
export type PutMultiplacerProjectsRoomSyncSettingsApiResponse =
  /** status 200 Successful response */ {
    drofusRooms: boolean;
    drofusSpecifiedArticles: boolean;
    deriveRoomExtraIfcInfo: boolean;
    validateSpecifiedArticles: boolean;
    standardRoomValidationDisciplines: string[];
    mlPredictCeilingDevices: boolean;
  };
export type PutMultiplacerProjectsRoomSyncSettingsApiArg = {
  body: {
    projectNo: number;
    roomSync: {
      drofusRooms?: boolean;
      drofusSpecifiedArticles?: boolean;
      deriveRoomExtraIfcInfo?: boolean;
      validateSpecifiedArticles?: boolean;
      standardRoomValidationDisciplines?: string[];
      mlPredictCeilingDevices?: boolean;
    };
  };
};
export type GetMultiplacerProjectArticleValidationApiResponse =
  /** status 200 Successful response */ {
    ignoredCompCodes: {
      compCode: string;
      description: string;
      addedBy: {
        userId: string;
        displayName: string;
      };
      addedAt: string;
    }[];
    canEdit: boolean;
  };
export type GetMultiplacerProjectArticleValidationApiArg = {
  projectNo: number;
};
export type PostMultiplacerProjectArticleValidationIgnoredApiResponse =
  /** status 200 Successful response */ {
    ok: true;
  };
export type PostMultiplacerProjectArticleValidationIgnoredApiArg = {
  body: {
    projectNo: number;
    compCode: string;
    ignored: boolean;
    description?: string;
  };
};
export type GetMultiplacerProjectArticleColoringApiResponse =
  /** status 200 Successful response */ {
    articleColorings: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusArticleProperties: {
      key: string;
      occurrenceField: string;
    }[];
  };
export type GetMultiplacerProjectArticleColoringApiArg = {
  projectNo: number;
};
export type PutMultiplacerProjectArticleColoringApiResponse =
  /** status 200 Successful response */ {
    articleColorings: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusArticleProperties: {
      key: string;
      occurrenceField: string;
    }[];
  };
export type PutMultiplacerProjectArticleColoringApiArg = {
  body: {
    articleColorings: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusArticleProperties: {
      key: string;
      occurrenceField: string;
    }[];
    projectNo: number;
  };
};
export type PostMultiplacerProjectAddProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    articleValidation?: {
      ignoredCompCodes: {
        compCode: string;
        description: string;
        addedBy: {
          userId: string;
          displayName: string;
        };
        addedAt: string;
      }[];
    };
    articleColorings?: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
        lastTriggeredAt?: string;
        lastTriggeredSlot?: string;
      };
      articleProperties?: {
        key: string;
        occurrenceField: string;
      }[];
    };
    roomSync?: {
      drofusRooms: boolean;
      drofusSpecifiedArticles: boolean;
      deriveRoomExtraIfcInfo: boolean;
      validateSpecifiedArticles: boolean;
      standardRoomValidationDisciplines: string[];
      mlPredictCeilingDevices: boolean;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      email?: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectAddProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      cadCompCodePath?: string;
      pnsPath?: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
      enrich?: {
        status: "idle" | "running" | "done";
        total: number;
        done: number;
        failed?: number;
        startedAt?: string | null;
        finishedAt?: string | null;
      };
      ventilation?: {
        compCodeDirectionRules?: {
          prefix: string;
          direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
          description?: string;
        }[];
        updatedAt?: string;
      };
      articleValidation?: {
        ignoredCompCodes: {
          compCode: string;
          description: string;
          addedBy: {
            userId: string;
            displayName: string;
          };
          addedAt: string;
        }[];
      };
      articleColorings?: {
        id: string;
        label: string;
        propertyKey: string;
        fallbackColor?: string;
        values: {
          value: string;
          label?: string;
          color: string;
        }[];
      }[];
      drofusInterface?: {
        occurrencesSyncSchedule?: {
          enabled?: boolean;
          days?: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
          hour?: number;
          minute?: number;
          timezone?: string;
          cronExpression?: string;
          pageSize?: number;
          maxRows?: number | null;
          updatedAt?: string;
          lastTriggeredAt?: string;
          lastTriggeredSlot?: string;
        };
        articleProperties?: {
          key: string;
          occurrenceField: string;
        }[];
      };
      roomSync?: {
        drofusRooms?: boolean;
        drofusSpecifiedArticles?: boolean;
        deriveRoomExtraIfcInfo?: boolean;
        validateSpecifiedArticles?: boolean;
        standardRoomValidationDisciplines?: string[];
        mlPredictCeilingDevices?: boolean;
      };
      members?: {
        userId?: any;
        displayName?: string;
        email?: string;
        role?: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
        permissions?: {
          modules?: {
            module:
              | "CEILING"
              | "ROOM_VALIDATION"
              | "EXPLORE"
              | "ROOM_NUMBERING"
              | "DROFUS_CHANGE_MANAGEMENT";
          }[];
          updatedAt?: string;
        };
        addedAt?: string;
        addedBy?: any;
      }[];
      invites?: {
        _id?: any;
        email: string;
        permissions?: {
          modules?: {
            module:
              | "CEILING"
              | "ROOM_VALIDATION"
              | "EXPLORE"
              | "ROOM_NUMBERING"
              | "DROFUS_CHANGE_MANAGEMENT";
          }[];
          updatedAt?: string;
        };
        invitedBy?: any;
        createdAt: string;
        expiresAt?: string;
        acceptedAt?: string;
        acceptedBy?: any;
        status?: "PENDING" | "ACCEPTED" | "REVOKED";
      }[];
    };
  };
};
export type GetMultiplacerProjectsApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    articleValidation?: {
      ignoredCompCodes: {
        compCode: string;
        description: string;
        addedBy: {
          userId: string;
          displayName: string;
        };
        addedAt: string;
      }[];
    };
    articleColorings?: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
        lastTriggeredAt?: string;
        lastTriggeredSlot?: string;
      };
      articleProperties?: {
        key: string;
        occurrenceField: string;
      }[];
    };
    roomSync?: {
      drofusRooms: boolean;
      drofusSpecifiedArticles: boolean;
      deriveRoomExtraIfcInfo: boolean;
      validateSpecifiedArticles: boolean;
      standardRoomValidationDisciplines: string[];
      mlPredictCeilingDevices: boolean;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      email?: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  }[];
export type GetMultiplacerProjectsApiArg = void;
export type PostProjectDrofusUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    drofusBaseUrl: string;
    drofusDb: string;
    drofusProject: string;
    hasApiKey: boolean;
    last4?: string;
    verifiedAt?: string;
    updatedAt?: string;
  };
export type PostProjectDrofusUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    settings: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      apiKey?: string;
    };
  };
};
export type GetMultiplacerProjectsSingleProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    articleValidation?: {
      ignoredCompCodes: {
        compCode: string;
        description: string;
        addedBy: {
          userId: string;
          displayName: string;
        };
        addedAt: string;
      }[];
    };
    articleColorings?: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
        lastTriggeredAt?: string;
        lastTriggeredSlot?: string;
      };
      articleProperties?: {
        key: string;
        occurrenceField: string;
      }[];
    };
    roomSync?: {
      drofusRooms: boolean;
      drofusSpecifiedArticles: boolean;
      deriveRoomExtraIfcInfo: boolean;
      validateSpecifiedArticles: boolean;
      standardRoomValidationDisciplines: string[];
      mlPredictCeilingDevices: boolean;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      email?: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type GetMultiplacerProjectsSingleProjectApiArg = {
  projectNo: number;
};
export type PostMultiplacerProjectEditProjectApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    articleValidation?: {
      ignoredCompCodes: {
        compCode: string;
        description: string;
        addedBy: {
          userId: string;
          displayName: string;
        };
        addedAt: string;
      }[];
    };
    articleColorings?: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
        lastTriggeredAt?: string;
        lastTriggeredSlot?: string;
      };
      articleProperties?: {
        key: string;
        occurrenceField: string;
      }[];
    };
    roomSync?: {
      drofusRooms: boolean;
      drofusSpecifiedArticles: boolean;
      deriveRoomExtraIfcInfo: boolean;
      validateSpecifiedArticles: boolean;
      standardRoomValidationDisciplines: string[];
      mlPredictCeilingDevices: boolean;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      email?: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectEditProjectApiArg = {
  body: {
    project: {
      projectNo: number;
      title: string;
      compCodePath: string;
      cadCompCodePath?: string;
      pnsPath?: string;
      areaPath?: string;
      mmiPath?: string;
      disciplineFileAttr?:
        | "fileAttr1"
        | "fileAttr2"
        | "fileAttr3"
        | "fileAttr4";
    };
  };
};
export type PostProjectVentilationUpdateSettingsApiResponse =
  /** status 200 Successful response */ {
    compCodeDirectionRules: {
      prefix: string;
      direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
      description?: string;
    }[];
    updatedAt?: string;
  };
export type PostProjectVentilationUpdateSettingsApiArg = {
  body: {
    projectNo: number;
    ventilation: {
      compCodeDirectionRules?: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerProjectsAddMemberApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    title: string;
    compCodePath: string;
    cadCompCodePath?: string;
    pnsPath?: string;
    areaPath?: string;
    mmiPath?: string;
    disciplineFileAttr?: "fileAttr1" | "fileAttr2" | "fileAttr3" | "fileAttr4";
    enrich?: {
      status: "idle" | "running" | "done";
      total: number;
      done: number;
      failed?: number;
      startedAt?: string | null;
      finishedAt?: string | null;
    };
    createdAt?: string;
    updatedAt?: string;
    ventilation?: {
      compCodeDirectionRules: {
        prefix: string;
        direction: "SUPPLY" | "EXHAUST" | "RETURN" | "TRANSFER";
        description?: string;
      }[];
      updatedAt?: string;
    };
    articleValidation?: {
      ignoredCompCodes: {
        compCode: string;
        description: string;
        addedBy: {
          userId: string;
          displayName: string;
        };
        addedAt: string;
      }[];
    };
    articleColorings?: {
      id: string;
      label: string;
      propertyKey: string;
      fallbackColor?: string;
      values: {
        value: string;
        label?: string;
        color: string;
      }[];
    }[];
    drofusInterface?: {
      occurrencesSyncSchedule?: {
        enabled: boolean;
        days: ("Sun" | "Mon" | "Tue" | "Wed" | "Thu" | "Fri" | "Sat")[];
        hour: number;
        minute: number;
        timezone: string;
        cronExpression: string;
        pageSize: number;
        maxRows: number | null;
        updatedAt?: string;
        lastTriggeredAt?: string;
        lastTriggeredSlot?: string;
      };
      articleProperties?: {
        key: string;
        occurrenceField: string;
      }[];
    };
    roomSync?: {
      drofusRooms: boolean;
      drofusSpecifiedArticles: boolean;
      deriveRoomExtraIfcInfo: boolean;
      validateSpecifiedArticles: boolean;
      standardRoomValidationDisciplines: string[];
      mlPredictCeilingDevices: boolean;
    };
    drofus?: {
      drofusBaseUrl: string;
      drofusDb: string;
      drofusProject: string;
      hasApiKey: boolean;
      last4?: string;
      verifiedAt?: string;
      updatedAt?: string;
    };
    members: {
      userId?: any;
      displayName: string;
      email?: string;
      role: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
      permissions?: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      addedAt?: string;
      addedBy?: any;
    }[];
    invites: {
      _id?: any;
      email: string;
      permissions: {
        modules: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
        }[];
        updatedAt?: string;
      };
      invitedBy?: any;
      createdAt: string;
      expiresAt?: string;
      acceptedAt?: string;
      acceptedBy?: any;
      status: "PENDING" | "ACCEPTED" | "REVOKED";
    }[];
  };
export type PostMultiplacerProjectsAddMemberApiArg = {
  body: {
    projectNo: number;
    userId?: string | any;
    role?: "OWNER" | "ADMIN" | "MEMBER" | "VIEWER";
    permissions?: {
      modules?: {
        module:
          | "CEILING"
          | "ROOM_VALIDATION"
          | "EXPLORE"
          | "ROOM_NUMBERING"
          | "DROFUS_CHANGE_MANAGEMENT";
      }[];
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerProjectsInviteByEmailApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    inviteEmail: string;
  };
export type PostMultiplacerProjectsInviteByEmailApiArg = {
  body: {
    projectNo: number;
    email: string;
    permissions?: {
      modules?: {
        module:
          | "CEILING"
          | "ROOM_VALIDATION"
          | "EXPLORE"
          | "ROOM_NUMBERING"
          | "DROFUS_CHANGE_MANAGEMENT";
      }[];
      updatedAt?: string;
    };
  };
};
export type PostMultiplacerProjectsUpdateMemberModulesApiResponse =
  /** status 200 Successful response */ {
    ok: true;
  };
export type PostMultiplacerProjectsUpdateMemberModulesApiArg = {
  body: {
    projectNo: number;
    userId?: string | any;
    modules: {
      module:
        | "CEILING"
        | "ROOM_VALIDATION"
        | "EXPLORE"
        | "ROOM_NUMBERING"
        | "DROFUS_CHANGE_MANAGEMENT";
    }[];
  };
};
export type PingApiResponse = /** status 200 Successful response */ {
  ping: string;
};
export type PingApiArg = void;
export type PostFunctionsDrofusOccurrencesDetailsApiResponse =
  /** status 200 Successful response */ {
    projectNo: number;
    capturedAt: string;
    entityType: "occurrence";
    occurrenceId: number;
    stableKey: string;
    normalized: {
      occurrence: {
        id: number;
        quantity?: number | null;
        existingQuantity?: number | null;
        netQuantity?: number | null;
        classificationNumber?: string | null;
        runNo?: string | null;
        name?: string | null;
        comment?: string | null;
        responsibility?: string | null;
        overriddenResponsibility?: string | null;
        priority?: string | null;
        statusText?: string | null;
        refString?: string | null;
        extendedTfmId?: string | null;
        refCompOcc?: (string | number) | null;
        specialFunctionalRole?: string | null;
        mmiCode?: string | null;
        mmiIds?: number[] | null;
        programmedStatusIds?: number[] | null;
        isSubOccurrence?: boolean | null;
        subOccurrenceDepth?: number | null;
        hasIfcGuids?: boolean | null;
        ifcGuids?: (string[] | null) | (string | null);
      };
      room: {
        id?: number | null;
        functionNo?: string | null;
        architectNo?: string | null;
        fullName?: string | null;
        classification103Code?: string | null;
        classification109Code?: string | null;
      };
      article: {
        id?: number | null;
        compCode?: string | null;
        properties?: {
          [key: string]: string | null;
        };
        name?: string | null;
        responsibility?: string | null;
        toBeDrawn?: boolean | null;
        bip?: boolean | null;
      };
      system: {
        primarySystemId?: number | null;
        isSystemComponent?: boolean | null;
        isComponent?: boolean | null;
        hasSystems?: string | null;
        systemMembership?: string | null;
      };
      needs: {
        electrical: boolean;
        ikt: boolean;
        automation: boolean;
        vvs: boolean;
        normalPowerKw?: number | null;
        standbyPowerKw?: number | null;
        networkOutletCount?: number | null;
        sdConnection?: boolean | null;
        roomControl?: boolean | null;
        internalAutomation?: boolean | null;
        busCommunication?: boolean | null;
        vvsWater: boolean;
        vvsDrainage: boolean;
        vvsVentilation: boolean;
        vvsCooling: boolean;
        vvsHeatEmission: boolean;
        vvsTemperatureHumidity: boolean;
        medicalGas: boolean;
      };
      occurrenceData: {
        controlSystemType?: string | null;
        controlledBy?: string | null;
        globalId?: string | null;
        modelName?: string | null;
        refLocRoomServe?: string | null;
        statedVoltage?: string | null;
        statedFrequency?: string | null;
        statedPowerW?: number | null;
        statedAmpere?: number | null;
        fieldbus?: boolean | null;
        networkName?: string | null;
        macAddress?: string | null;
        ipAddress?: string | null;
      };
    };
    sourceValues?: {
      [key: string]: string | number | boolean | string[] | number[] | null;
    };
    interfaceRelevant: boolean;
    interfaceRelevantReasons: string[];
    affectedDisciplines: (
      | "RIV"
      | "RIE"
      | "RIAut"
      | "RIKT"
      | "ARK"
      | "IARK"
      | "RKJ"
      | "RUT"
      | "HF"
      | "UNKNOWN"
    )[];
    source: "live";
    runId?: null;
    contentHash?: null;
    normalizedHash?: null;
  };
export type PostFunctionsDrofusOccurrencesDetailsApiArg = {
  body: {
    projectNo: number;
    occurrenceId: number;
  };
};
export type PostFunctionsDrofusArticlesDetailsApiResponse =
  /** status 200 Successful response */ {
    articleNumber: string;
    fetchedAt: string;
    fields: {
      id: string;
      name: string;
      propertyGroup: string;
      dataType: string;
      unit?: string;
    }[];
    article: {
      [key: string]: any;
    } | null;
  };
export type PostFunctionsDrofusArticlesDetailsApiArg = {
  body: {
    projectNo: number;
    articleNumber: string;
  };
};
export type GetFunctionsPingApiResponse =
  /** status 200 Successful response */ any;
export type GetFunctionsPingApiArg = void;
export type PostMultiplacerEnrichRoomApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    roomNumber: string;
    roomNumbering?: {
      suggested?: string;
      run?: {
        methodKey: "NRH" | "DRAMMEN_SYKEHUS";
        runBy: {
          _id: string;
          name: string;
        };
        runAt: string;
      };
      value?: string;
      updatedBy?: {
        _id: string;
        name: string;
      };
      updatedAt?: string;
      approval?: {
        approvedBy: {
          _id: string;
          name: string;
        };
        approvedAt: string;
      };
      evaluation?: {
        status:
          | "NOT_REVIEWED"
          | "CORRECT"
          | "INCORRECT"
          | "PARTLY_CORRECT"
          | "UNCLEAR";
        comment?: string;
        expectedValue?: string;
        reviewedBy?: {
          _id: string;
          name: string;
        };
        reviewedAt?: string;
      };
    };
    roomName?: string;
    airFlow?: {
      selected?: {
        supply?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
        exhaust?: {
          value: number;
          source: "excel" | "manual";
          selectedAt?: string;
          selectedBy?: {
            _id: string;
            name: string;
          };
        };
      };
      excel?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        sourceRef?: {
          system?: string;
          id?: string;
          fileName?: string;
          importId?: string;
        };
        importedAt?: string;
        importedBy?: {
          _id: string;
          name: string;
        };
      };
      manual?: {
        supply?: number;
        exhaust?: number;
        comment?: string;
        updatedAt?: string;
        updatedBy?: {
          _id: string;
          name: string;
        };
      };
      comments?: {
        _id: string;
        message: string;
        createdBy: {
          _id: string;
          name: string;
        };
        createdAt: string;
        editedAt?: string | null;
        deletedAt?: string | null;
      }[];
    };
    ceilingComments: {
      _id: string;
      message: string;
      createdBy: {
        _id: string;
        name: string;
      };
      createdAt: string;
      editedAt?: string | null;
      deletedAt?: string | null;
    }[];
    supplyAirFlow?: number;
    returnAirFlow?: number;
    rfpStatus?: string | null;
    rfpMalRom?: string | null;
    drStatus?: string | null;
    designDeviationStatus?: string | null;
    updatedAt?: string;
    multiplacerCeilingDevicesLocked?: {
      bool: boolean;
      lockedAt?: string;
      createdBy?: {
        _id: string;
        name: string;
      };
    };
    validation?: {
      standardRoom?: {
        [key: string]: {
          standardRoomId: string;
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          engineVersion?: string;
          sourceFingerprint?: string;
          validatedAt: string;
          validatedBy: string;
          note?: string;
        };
      };
      specifiedArticles?: {
        summary: {
          matchRatePct: number;
          itemsTotal: number;
          itemsMatched: number;
          itemsMissing: number;
          itemsExtra: number;
          status:
            | "OK"
            | "WARNING"
            | "ERROR"
            | "invalidGeometry"
            | "noStandardRoom";
        };
        quantities?: {
          expectedQuantityTotal: number;
          observedQuantityTotal: number;
          quantityDeltaTotal: number;
        };
        comparison: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
        }[];
        ignoredComparison?: {
          compCode: string;
          label?: string | null;
          standardCount: number;
          instanceCount: number;
          delta: number;
          reason: "PROJECT_IGNORED_COMPCODE";
        }[];
        appliedSettings?: {
          ignoredCompCodes: {
            compCode: string;
            description: string;
            addedBy: {
              userId: string;
              displayName: string;
            };
            addedAt: string;
          }[];
        };
        engineVersion?: string;
        sourceFingerprint?: string | null;
        validatedAt: string;
        validatedBy: string;
        note?: string | null;
        perResponsibility?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
        perListType?: {
          [key: string]: {
            summary: {
              matchRatePct: number;
              itemsTotal: number;
              itemsMatched: number;
              itemsMissing: number;
              itemsExtra: number;
              status:
                | "OK"
                | "WARNING"
                | "ERROR"
                | "invalidGeometry"
                | "noStandardRoom";
            };
            quantities?: {
              expectedQuantityTotal: number;
              observedQuantityTotal: number;
              quantityDeltaTotal: number;
            };
            comparison: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
            }[];
            ignoredComparison?: {
              compCode: string;
              label?: string | null;
              standardCount: number;
              instanceCount: number;
              delta: number;
              reason: "PROJECT_IGNORED_COMPCODE";
            }[];
          };
        };
      };
    };
    validationDecisions?: {
      standardRoom?: {
        [key: string]: {
          current?: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          } | null;
          history: {
            status: "APPROVED" | "APPROVED_WITH_DEVIATIONS" | "NEEDS_CHECK";
            comment?: string | null;
            updatedByUserId: string;
            updatedByUserName: string;
            updatedAt: string;
          }[];
          comments: {
            _id: string;
            message: string;
            createdBy: {
              _id: string;
              name: string;
            };
            createdAt: string;
            editedAt?: string | null;
            deletedAt?: string | null;
          }[];
        };
      };
    };
    extraIfcInfo?: {
      pns?: string | null;
      floor?: string | null;
      mmi?: string | null;
      ceilingMmi?: string | null;
      building?: string | null;
    };
    mlPredictedDevices?: {
      deviceCategory:
        | "CHILLER_DEVICE"
        | "DEFAULT_DEVICE"
        | "DOOR"
        | "DOWN_LIGHT_DEVICE"
        | "FIRE_SUPPRESSION_DEVICE"
        | "FURNITURE"
        | "LIGHT_DEVICE_CIRCULAR"
        | "LIGHT_DEVICE"
        | "RETURN_AIR_DEVICE"
        | "SENSOR_DEVICE"
        | "SUPPLY_AIR_DEVICE"
        | "WINDOW";
      direction: number[];
      coordinate: number[];
    }[];
    mlPredictionMetadata?: {
      importedAt: string;
      generatedAt?: string | null;
      source: string;
      blobName: string;
    };
    existsInRfp?: boolean;
    existsInMcbim?: boolean;
    specifiedArticles?: {
      compCode: string;
      quantity: number;
      name?: string;
      responsibility?: string;
      category?: string;
      flags?: {
        toBeDrawn?: boolean;
        bip?: boolean;
      };
      sourceRef?: {
        system?: string;
        id?: string;
      };
    }[];
    specifiedArticlesSync?: {
      syncedAt: string;
      source?: string;
      version?: string;
    };
    polygonSnapshot?: {
      polygon: number[][];
      polygonHash: string;
    };
    ceilingGridIntersection?: {
      x: number;
      y: number;
      direction?: {
        x: number;
        y: number;
      };
    };
    ceilingFreeTiles?: {
      gridIndex: number;
      rowIndex: number;
      columnIndex: number;
      boundingBox: number[][];
    }[];
    mcbimItemsSnapshot?: {
      meta: {
        builtAt: string;
        runId: string;
        sourceKey: string;
      };
      items: {
        globalId: string;
        discipline?: string | null;
        system?: string | null;
        name?: string | null;
        typeName?: string | null;
        instanceClass: string;
        mmi?: string | null;
        compCode?: string | null;
        bboxSnapshot?: {
          bbox: number[][];
          bboxHash: string;
          hashVersion: 1;
        } | null;
        building?: string | null;
      }[];
    };
  } | null;
export type PostMultiplacerEnrichRoomApiArg = {
  body: {
    projectNo: number;
    roomNr: string;
    jobTypes: (
      | "specifiedArticles"
      | "mlPredictDevices"
      | "deriveRoomExtraIfcInfo"
      | "addIfcInfo"
      | string
    )[];
    dryRun?: boolean;
  };
};
export type PostMultiplacerSyncStartApiResponse =
  /** status 200 Successful response */ {
    queuedBatches: number;
    totalRooms: number;
  };
export type PostMultiplacerSyncStartApiArg = {
  body: {
    projectNo: number;
    jobTypes?: (
      | "specifiedArticles"
      | "mlPredictDevices"
      | "deriveRoomExtraIfcInfo"
      | "addIfcInfo"
      | string
    )[];
  };
};
export type PostProjectDrofusVerifyConnectionApiResponse =
  /** status 200 Successful response */
    | {
        ok: true;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs: number;
      }
    | {
        ok: false;
        usedStoredKey: boolean;
        last4?: string;
        elapsedMs?: number;
        error: {
          origin: "upstream" | "config" | "network" | "unknown";
          httpStatus?: number;
          code?: string;
          message: string;
        };
      };
export type PostProjectDrofusVerifyConnectionApiArg = {
  body: {
    projectNo: number;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesSyncApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    queued: true;
    runId: string;
    previousRunId: string | null;
    projectNo: number;
    pageSize: number;
    maxRows: number | null;
    dryRun: boolean;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesSyncApiArg = {
  body: {
    projectNo: number;
    top?: number;
    maxRows?: number;
    testMode?: boolean;
    dryRun?: boolean;
  };
};
export type PostMultiplacerDrofusInterfaceOccurrencesDiffLatestApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    projectNo: number;
    runId: string;
    baseRunId: string;
    addedCount: number;
    updatedCount: number;
    removedCount: number;
    changeEventCount: number;
    queuedLogEnrichmentOccurrenceCount?: number;
  };
export type PostMultiplacerDrofusInterfaceOccurrencesDiffLatestApiArg = {
  body: {
    projectNo: number;
  };
};
export type PostFunctionsDrofusOccurrencesTestApiResponse =
  /** status 200 Successful response */ {
    ok: boolean;
    projectNo: number;
    elapsedMs?: number;
    fetchedRows?: number;
    usedParams?: {
      top: number | null;
      maxRows?: number | null;
      selectAll?: boolean;
      filter: string | null;
      select: string | null;
    };
    sample?: any[];
    error?: any;
  };
export type PostFunctionsDrofusOccurrencesTestApiArg = {
  body: {
    projectNo: number;
    top?: number;
    sample?: number;
    maxRows?: number;
    selectAll?: boolean;
    select?: string;
    filter?: string;
  };
};
export type PostFunctionsDrofusItemsOptionsTestApiResponse =
  /** status 200 Successful response */ {
    ok: boolean;
    projectNo: number;
    resource: "items";
    depth: number;
    elapsedMs?: number;
    upstreamStatus?: number;
    upstreamStatusText?: string;
    contentType?: string;
    body?: any;
    error?: any;
  };
export type PostFunctionsDrofusItemsOptionsTestApiArg = {
  body: {
    projectNo: number;
    depth?: number;
  };
};
export type PostFunctionsDrofusOccurrencesOptionsTestApiResponse =
  /** status 200 Successful response */ {
    ok: boolean;
    projectNo: number;
    resource: "occurrences";
    depth: number;
    elapsedMs?: number;
    upstreamStatus?: number;
    upstreamStatusText?: string;
    contentType?: string;
    body?: any;
    error?: any;
  };
export type PostFunctionsDrofusOccurrencesOptionsTestApiArg = {
  body: {
    projectNo: number;
    depth?: number;
  };
};
export type PostFunctionsDrofusApiProbeTestApiResponse =
  /** status 200 Successful response */ {
    ok: boolean;
    projectNo: number;
    target?: "swagger" | "project";
    method?: "GET" | "OPTIONS";
    path?: string;
    query?: string | null;
    search?: string[];
    elapsedMs?: number;
    upstreamUrl?: string;
    upstreamStatus?: number;
    upstreamStatusText?: string;
    contentType?: string;
    textLength?: number;
    matches?: {
      path: string;
      value?: any;
    }[];
    body?: any;
    bodyPreview?: string;
    truncated?: boolean;
    error?: any;
  };
export type PostFunctionsDrofusApiProbeTestApiArg = {
  body: {
    projectNo: number;
    target?: "swagger" | "project";
    method?: "GET" | "OPTIONS";
    path?: string;
    query?: string;
    search?: string;
    includeBody?: boolean;
    maxBodyChars?: number;
  };
};
export type PostFunctionsDrofusOccurrencesLogsTestApiResponse =
  /** status 200 Successful response */ {
    ok: boolean;
    projectNo: number;
    occurrenceId: number;
    elapsedMs?: number;
    upstreamStatus?: number;
    upstreamStatusText?: string;
    contentType?: string;
    usedParams?: {
      top: number | null;
      select: string | null;
    };
    body?: any;
    error?: any;
  };
export type PostFunctionsDrofusOccurrencesLogsTestApiArg = {
  body: {
    projectNo: number;
    occurrenceId: number;
    top?: number;
    select?: string;
  };
};
export type PostFunctionsDrofusRoomsOccurrencesValidateApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    projectNo: number;
    roomNumber: string;
    validatedAt: string;
    elapsedMs: number;
    validation: {
      summary: {
        matchRatePct: number;
        itemsTotal: number;
        itemsMatched: number;
        itemsMissing: number;
        itemsExtra: number;
        status:
          | "OK"
          | "WARNING"
          | "ERROR"
          | "invalidGeometry"
          | "noStandardRoom";
      };
      quantities?: {
        expectedQuantityTotal: number;
        observedQuantityTotal: number;
        quantityDeltaTotal: number;
      };
      comparison: {
        compCode: string;
        label?: string | null;
        standardCount: number;
        instanceCount: number;
        delta: number;
      }[];
      ignoredComparison?: {
        compCode: string;
        label?: string | null;
        standardCount: number;
        instanceCount: number;
        delta: number;
        reason: "PROJECT_IGNORED_COMPCODE";
      }[];
      appliedSettings?: {
        ignoredCompCodes: {
          compCode: string;
          description: string;
          addedBy: {
            userId: string;
            displayName: string;
          };
          addedAt: string;
        }[];
      };
      engineVersion?: string;
      sourceFingerprint?: string | null;
      validatedAt: string;
      validatedBy: string;
      note?: string | null;
      perResponsibility?: {
        [key: string]: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          ignoredComparison?: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
            reason: "PROJECT_IGNORED_COMPCODE";
          }[];
        };
      };
      perListType?: {
        [key: string]: {
          summary: {
            matchRatePct: number;
            itemsTotal: number;
            itemsMatched: number;
            itemsMissing: number;
            itemsExtra: number;
            status:
              | "OK"
              | "WARNING"
              | "ERROR"
              | "invalidGeometry"
              | "noStandardRoom";
          };
          quantities?: {
            expectedQuantityTotal: number;
            observedQuantityTotal: number;
            quantityDeltaTotal: number;
          };
          comparison: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
          }[];
          ignoredComparison?: {
            compCode: string;
            label?: string | null;
            standardCount: number;
            instanceCount: number;
            delta: number;
            reason: "PROJECT_IGNORED_COMPCODE";
          }[];
        };
      };
    } | null;
  };
export type PostFunctionsDrofusRoomsOccurrencesValidateApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
  };
};
export type PostFunctionsDrofusRoomsOccurrencesLiveApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    projectNo: number;
    roomNumber: string;
    fetchedAt: string;
    elapsedMs: number;
    fetchedRows: number;
    usedParams: {
      maxRows: number;
      jRoomsOnly: boolean;
      filter: string;
      select: string;
    };
    items: {
      occurrenceId: number | null;
      quantity: number | null;
      existingQuantity: number | null;
      netQuantity: number | null;
      equipmentListTypeId: number | null;
      equipmentListTypeName: string | null;
      roomId: number | null;
      roomFunctionNo: string | null;
      roomArchitectNo: string | null;
      roomFullName: string | null;
      articleId: number | null;
      compCode: string | null;
      articleName: string | null;
      articleResponsibility: string | null;
      articleToBeDrawn: boolean | null;
      articleBip: boolean | null;
      occurrenceResponsibility: string | null;
      responsibility: string | null;
      statusText: string | null;
      nameOrItemName: string | null;
      sourceValues: {
        [key: string]: any;
      };
    }[];
  };
export type PostFunctionsDrofusRoomsOccurrencesLiveApiArg = {
  body: {
    projectNo: number;
    roomNumber: string;
    maxRows?: number;
    jRoomsOnly?: boolean;
  };
};
export type PostSharedZodPingApiResponse =
  /** status 200 Successful response */ {
    ok: true;
    parsed: {
      message: string;
      count?: number;
    };
  };
export type PostSharedZodPingApiArg = {
  body: {
    message: string;
    count?: number;
  };
};
export type GetSharedStaticDeviceTypeSettingsApiResponse =
  /** status 200 Successful response */ {
    [key: string]: {
      color: string;
      showDirectionInViewer: boolean;
      label: string;
      description?: string;
    };
  };
export type GetSharedStaticDeviceTypeSettingsApiArg = void;
export type PostSharedCalculateEarthingApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
export type PostSharedCalculateEarthingApiArg = {
  body: {
    apparatusFoundations: {
      id: string;
      points: number[][];
    }[];
  };
};
export type PostMultiplacerReleaseNotesDeployNotesApiResponse =
  /** status 200 Successful response */ {
    id: string;
  };
export type PostMultiplacerReleaseNotesDeployNotesApiArg = {
  body: {
    mergedAt: string;
    gitSha?: string;
    pr?: {
      id?: number;
      title?: string;
    };
    internalNote?: string;
    changeItems?: {
      userFacing?: boolean;
      title: string;
      type: "added" | "changed" | "fixed";
      module: "CEILING" | "ROOM_VALIDATION" | "EXPLORE" | "ROOM_NUMBERING";
      area: string;
      impact?: "low" | "medium" | "high";
      text: string;
      media?: {
        kind: "image" | "video";
        blobPath: string;
        posterBlobPath?: string;
        contentType?: string;
        caption?: string;
        width?: number;
        height?: number;
        durationSec?: number;
      }[];
    }[];
  };
};
export type GetMultiplacerReleaseNotesPublishedApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    version: string;
    summary?: string | null;
    releaseDate: string;
    items: {
      type: "added" | "changed" | "fixed";
      area: string;
      title?: string | null;
      module: "CEILING" | "ROOM_VALIDATION" | "EXPLORE" | "ROOM_NUMBERING";
      impact?: "low" | "medium" | "high";
      text: string;
      media?: {
        kind: "image" | "video";
        blobPath: string;
        posterBlobPath?: string;
        contentType?: string;
        caption?: string;
        width?: number;
        height?: number;
        durationSec?: number;
      }[];
    }[];
    includedDeployNoteIds: string[];
    isPublished: boolean;
  }[];
export type GetMultiplacerReleaseNotesPublishedApiArg = void;
export type GetMultiplacerReleaseNotesDeployNotesUnpublishedApiResponse =
  /** status 200 Successful response */ {
    items: {
      _id?: any;
      mergedAt: string;
      gitSha?: string;
      pr?: {
        id?: number;
        title?: string;
      };
      internalNote?: string;
      changeItems: {
        _id: string;
        userFacing: boolean;
        title: string;
        type: "added" | "changed" | "fixed";
        module: "CEILING" | "ROOM_VALIDATION" | "EXPLORE" | "ROOM_NUMBERING";
        area: string;
        impact?: "low" | "medium" | "high";
        text: string;
        media?: {
          kind: "image" | "video";
          blobPath: string;
          posterBlobPath?: string;
          contentType?: string;
          caption?: string;
          width?: number;
          height?: number;
          durationSec?: number;
        }[];
      }[];
      publishedInReleaseId?: string | null;
    }[];
    nextCursor?: string;
  };
export type GetMultiplacerReleaseNotesDeployNotesUnpublishedApiArg = {
  limit?: number;
  cursor?: string;
  module?:
    | "CEILING"
    | "ROOM_VALIDATION"
    | "EXPLORE"
    | "ROOM_NUMBERING"
    | "DROFUS_CHANGE_MANAGEMENT";
};
export type PostMultiplacerReleaseNotesPublishApiResponse =
  /** status 200 Successful response */ {
    releaseId: string;
  };
export type PostMultiplacerReleaseNotesPublishApiArg = {
  body: {
    version: string;
    title?: string | null;
    summary?: string | null;
    deployNoteIds: (string | any)[];
  };
};
export type DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiResponse =
  /** status 200 Successful response */ {
    deletedFromBlob: boolean;
    removedFromDb: boolean;
  };
export type DeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaApiArg =
  {
    deployNoteId: string;
    changeItemId: string;
    blobPath: string;
  };
export type GetMultiplacerReleaseNotesStatusApiResponse =
  /** status 200 Successful response */ {
    latestReleaseId: string | null;
    lastSeenReleaseId: string | null;
    hasUnread: boolean;
  };
export type GetMultiplacerReleaseNotesStatusApiArg = void;
export type PostMultiplacerReleaseNotesMarkSeenApiResponse =
  /** status 200 Successful response */ {
    ok: true;
  };
export type PostMultiplacerReleaseNotesMarkSeenApiArg = {
  body: {
    releaseId: string;
  };
};
export type GetRoutingGraphListApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  }[];
export type GetRoutingGraphListApiArg = {
  projectNo: number;
  floorName: string;
};
export type PostRoutingGraphSaveApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
export type PostRoutingGraphSaveApiArg = {
  body: {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind?: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
};
export type DeleteRoutingGraphDeleteApiResponse =
  /** status 200 Successful response */ {
    acknowledged: boolean;
    deletedCount: number;
  };
export type DeleteRoutingGraphDeleteApiArg = {
  graphId: string;
};
export type GetMcappsProjectPnsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    parentId: string | null;
    props: {
      pnsId: string;
      title: string;
    };
  }[];
export type GetMcappsProjectPnsApiArg = {
  projectNo: number;
};
export type PostEarthingCalculateApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    projectNo: number;
    systemCode: string;
    systemName?: string;
    floorName: string;
    roomNumber?: string;
    nodes: {
      id: string;
      posM: number[];
      kind: "JUNCTION" | "DEVICE_PORT";
      deviceRef?: {
        deviceId: string;
        compCodeSnapshot?: string;
        port?: "IN" | "OUT";
      };
      rooms?: string[];
      perimeter?: boolean;
    }[];
    edges: {
      id: string;
      from: string;
      to: string;
      compCode: string;
      profile: "CIRCULAR" | "RECTANGULAR";
      size:
        | {
            diameterM: number;
          }
        | {
            widthM: number;
            heightM: number;
          };
    }[];
  };
export type PostEarthingCalculateApiArg = {
  body: {
    apparatusFoundations: {
      id: string;
      points: number[][];
    }[];
  };
};
export type GetEarthingRunsApiResponse = /** status 200 Successful response */ {
  items: {
    _id?: string;
    route: "/earthing/calculate";
    source: "api";
    createdAt: string;
    startedAt: string;
    finishedAt?: string;
    durationMs?: number;
    status: "success" | "error";
    request: {
      requestId?: string;
      ipHash?: string;
      userAgent?: string;
      client?: {
        clientName?: string;
        clientVersion?: string;
        runtimeName?: string;
        runtimeVersion?: string;
        machineNameHash?: string;
        userNameHash?: string;
      };
      rawBody?: any;
      input?: {
        apparatusFoundations: {
          id: string;
          points: number[][];
        }[];
      };
    };
    response: {
      output?: {
        _id?: any;
        projectNo: number;
        systemCode: string;
        systemName?: string;
        floorName: string;
        roomNumber?: string;
        nodes: {
          id: string;
          posM: number[];
          kind: "JUNCTION" | "DEVICE_PORT";
          deviceRef?: {
            deviceId: string;
            compCodeSnapshot?: string;
            port?: "IN" | "OUT";
          };
          rooms?: string[];
          perimeter?: boolean;
        }[];
        edges: {
          id: string;
          from: string;
          to: string;
          compCode: string;
          profile: "CIRCULAR" | "RECTANGULAR";
          size:
            | {
                diameterM: number;
              }
            | {
                widthM: number;
                heightM: number;
              };
        }[];
      };
      error?: {
        name?: string;
        message: string;
        code?: string;
        stack?: string;
      };
    };
    meta?: {
      inputBytes?: number;
      outputBytes?: number;
      apparatusFoundationCount?: number;
      nodeCount?: number;
      edgeCount?: number;
    };
  }[];
  limit: number;
  hasMore: boolean;
};
export type GetEarthingRunsApiArg = {
  limit?: number;
};
export type PostMultiplacerViewsApiResponse =
  /** status 200 Successful response */
    | {
        _id: string;
        projectNo: number;
        createdAt: string;
        createdBy: {
          _id: string;
          name: string;
        };
        view: {
          schemaVersion: 1;
          visibility:
            | {
                mode: "INSTANCE_CLASS";
                ifcClasses: {
                  ifcClass: string;
                  opacity: number;
                }[];
              }
            | {
                mode: "DISCIPLINE";
                disciplines: string[];
              };
          componentColorMode:
            | "SYSTEM_AND_CLASS"
            | "MULTIPLACER_COLORS"
            | "MMI"
            | "DISCIPLINE_COLORS"
            | "PRIMARY_SYSTEM";
          articleColoringId: string | null;
          roomColoringId:
            | (
                | (
                    | "SPACE_BELONG_TO_STANDARD_ROOM"
                    | "SUPPLY_AIR_FLOW"
                    | "RETURN_AIR_FLOW"
                    | "MMI"
                    | "CEILING_MMI"
                    | "DR_STATUS"
                    | "DESIGN_DEVIATION_STATUS"
                    | "ROOM_NUMBERING"
                    | "CEILING_COMMENTS"
                  )
                | string
                | "specifiedArticles.overall"
                | string
              )
            | null;
          roomPanelTab:
            | (
                | "CEILING_MULTIPLACER_PRODUCTS"
                | "CEILING_STANDARD_ROOM"
                | "CEILING_VALIDATIONS"
                | "CEILING_AI_PREDICTIONS"
                | "CEILING_COMMENTS"
                | "ROOM_SECTION_VIEWS"
                | "RFP_STANDARD_ROOM_DIFF"
                | "ROOM_SPECIFIED_ARTICLES"
                | "ROOM_NUMBERING_DETAILS"
                | "ROOM_INFO"
                | "ROOM_DROFUS_CHANGES"
                | null
              )
            | null;
          modules: {
            ROOM_VALIDATION: {
              occurrences: {
                filterMode: "listType" | "responsibility";
                listType: string | null;
                responsibility: string | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
              standardRoom: {
                discipline: ("E" | "V" | null) | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
            };
          };
        };
        kind: "preset";
        name: string;
        description?: string;
        source: "user";
        scope: "personal" | "project";
        updatedAt?: string;
      }
    | {
        _id: string;
        projectNo: number;
        createdAt: string;
        createdBy: {
          _id: string;
          name: string;
        };
        view: {
          schemaVersion: 1;
          visibility:
            | {
                mode: "INSTANCE_CLASS";
                ifcClasses: {
                  ifcClass: string;
                  opacity: number;
                }[];
              }
            | {
                mode: "DISCIPLINE";
                disciplines: string[];
              };
          componentColorMode:
            | "SYSTEM_AND_CLASS"
            | "MULTIPLACER_COLORS"
            | "MMI"
            | "DISCIPLINE_COLORS"
            | "PRIMARY_SYSTEM";
          articleColoringId: string | null;
          roomColoringId:
            | (
                | (
                    | "SPACE_BELONG_TO_STANDARD_ROOM"
                    | "SUPPLY_AIR_FLOW"
                    | "RETURN_AIR_FLOW"
                    | "MMI"
                    | "CEILING_MMI"
                    | "DR_STATUS"
                    | "DESIGN_DEVIATION_STATUS"
                    | "ROOM_NUMBERING"
                    | "CEILING_COMMENTS"
                  )
                | string
                | "specifiedArticles.overall"
                | string
              )
            | null;
          roomPanelTab:
            | (
                | "CEILING_MULTIPLACER_PRODUCTS"
                | "CEILING_STANDARD_ROOM"
                | "CEILING_VALIDATIONS"
                | "CEILING_AI_PREDICTIONS"
                | "CEILING_COMMENTS"
                | "ROOM_SECTION_VIEWS"
                | "RFP_STANDARD_ROOM_DIFF"
                | "ROOM_SPECIFIED_ARTICLES"
                | "ROOM_NUMBERING_DETAILS"
                | "ROOM_INFO"
                | "ROOM_DROFUS_CHANGES"
                | null
              )
            | null;
          modules: {
            ROOM_VALIDATION: {
              occurrences: {
                filterMode: "listType" | "responsibility";
                listType: string | null;
                responsibility: string | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
              standardRoom: {
                discipline: ("E" | "V" | null) | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
            };
          };
        };
        kind: "snapshot";
        context: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
          floorName: string;
          building: string;
          camera: {
            rotation: number;
            zoom: number;
            centerWorld: {
              x: number;
              y: number;
            };
          };
          selectedSpaceNumber?: string;
        };
      };
export type PostMultiplacerViewsApiArg = {
  body: {
    projectNo: number;
    data:
      | {
          name: string;
          description?: string;
          view: {
            schemaVersion: 1;
            visibility:
              | {
                  mode: "INSTANCE_CLASS";
                  ifcClasses: {
                    ifcClass: string;
                    opacity: number;
                  }[];
                }
              | {
                  mode: "DISCIPLINE";
                  disciplines: string[];
                };
            componentColorMode:
              | "SYSTEM_AND_CLASS"
              | "MULTIPLACER_COLORS"
              | "MMI"
              | "DISCIPLINE_COLORS"
              | "PRIMARY_SYSTEM";
            articleColoringId: string | null;
            roomColoringId:
              | (
                  | (
                      | "SPACE_BELONG_TO_STANDARD_ROOM"
                      | "SUPPLY_AIR_FLOW"
                      | "RETURN_AIR_FLOW"
                      | "MMI"
                      | "CEILING_MMI"
                      | "DR_STATUS"
                      | "DESIGN_DEVIATION_STATUS"
                      | "ROOM_NUMBERING"
                      | "CEILING_COMMENTS"
                    )
                  | string
                  | "specifiedArticles.overall"
                  | string
                )
              | null;
            roomPanelTab:
              | (
                  | "CEILING_MULTIPLACER_PRODUCTS"
                  | "CEILING_STANDARD_ROOM"
                  | "CEILING_VALIDATIONS"
                  | "CEILING_AI_PREDICTIONS"
                  | "CEILING_COMMENTS"
                  | "ROOM_SECTION_VIEWS"
                  | "RFP_STANDARD_ROOM_DIFF"
                  | "ROOM_SPECIFIED_ARTICLES"
                  | "ROOM_NUMBERING_DETAILS"
                  | "ROOM_INFO"
                  | "ROOM_DROFUS_CHANGES"
                  | null
                )
              | null;
            modules: {
              ROOM_VALIDATION: {
                occurrences: {
                  filterMode: "listType" | "responsibility";
                  listType: string | null;
                  responsibility: string | null;
                  tableFilter: {
                    search: string;
                    onlyDeviations: boolean;
                  };
                };
                standardRoom: {
                  discipline: ("E" | "V" | null) | null;
                  tableFilter: {
                    search: string;
                    onlyDeviations: boolean;
                  };
                };
              };
            };
          };
          scope: "personal" | "project";
          kind: "preset";
        }
      | {
          view: {
            schemaVersion: 1;
            visibility:
              | {
                  mode: "INSTANCE_CLASS";
                  ifcClasses: {
                    ifcClass: string;
                    opacity: number;
                  }[];
                }
              | {
                  mode: "DISCIPLINE";
                  disciplines: string[];
                };
            componentColorMode:
              | "SYSTEM_AND_CLASS"
              | "MULTIPLACER_COLORS"
              | "MMI"
              | "DISCIPLINE_COLORS"
              | "PRIMARY_SYSTEM";
            articleColoringId: string | null;
            roomColoringId:
              | (
                  | (
                      | "SPACE_BELONG_TO_STANDARD_ROOM"
                      | "SUPPLY_AIR_FLOW"
                      | "RETURN_AIR_FLOW"
                      | "MMI"
                      | "CEILING_MMI"
                      | "DR_STATUS"
                      | "DESIGN_DEVIATION_STATUS"
                      | "ROOM_NUMBERING"
                      | "CEILING_COMMENTS"
                    )
                  | string
                  | "specifiedArticles.overall"
                  | string
                )
              | null;
            roomPanelTab:
              | (
                  | "CEILING_MULTIPLACER_PRODUCTS"
                  | "CEILING_STANDARD_ROOM"
                  | "CEILING_VALIDATIONS"
                  | "CEILING_AI_PREDICTIONS"
                  | "CEILING_COMMENTS"
                  | "ROOM_SECTION_VIEWS"
                  | "RFP_STANDARD_ROOM_DIFF"
                  | "ROOM_SPECIFIED_ARTICLES"
                  | "ROOM_NUMBERING_DETAILS"
                  | "ROOM_INFO"
                  | "ROOM_DROFUS_CHANGES"
                  | null
                )
              | null;
            modules: {
              ROOM_VALIDATION: {
                occurrences: {
                  filterMode: "listType" | "responsibility";
                  listType: string | null;
                  responsibility: string | null;
                  tableFilter: {
                    search: string;
                    onlyDeviations: boolean;
                  };
                };
                standardRoom: {
                  discipline: ("E" | "V" | null) | null;
                  tableFilter: {
                    search: string;
                    onlyDeviations: boolean;
                  };
                };
              };
            };
          };
          context: {
            module:
              | "CEILING"
              | "ROOM_VALIDATION"
              | "EXPLORE"
              | "ROOM_NUMBERING"
              | "DROFUS_CHANGE_MANAGEMENT";
            floorName: string;
            building: string;
            camera: {
              rotation: number;
              zoom: number;
              centerWorld: {
                x: number;
                y: number;
              };
            };
            selectedSpaceNumber?: string;
          };
          kind: "snapshot";
        };
  };
};
export type GetMultiplacerViewsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    createdAt: string;
    createdBy: {
      _id: string;
      name: string;
    };
    view: {
      schemaVersion: 1;
      visibility:
        | {
            mode: "INSTANCE_CLASS";
            ifcClasses: {
              ifcClass: string;
              opacity: number;
            }[];
          }
        | {
            mode: "DISCIPLINE";
            disciplines: string[];
          };
      componentColorMode:
        | "SYSTEM_AND_CLASS"
        | "MULTIPLACER_COLORS"
        | "MMI"
        | "DISCIPLINE_COLORS"
        | "PRIMARY_SYSTEM";
      articleColoringId: string | null;
      roomColoringId:
        | (
            | (
                | "SPACE_BELONG_TO_STANDARD_ROOM"
                | "SUPPLY_AIR_FLOW"
                | "RETURN_AIR_FLOW"
                | "MMI"
                | "CEILING_MMI"
                | "DR_STATUS"
                | "DESIGN_DEVIATION_STATUS"
                | "ROOM_NUMBERING"
                | "CEILING_COMMENTS"
              )
            | string
            | "specifiedArticles.overall"
            | string
          )
        | null;
      roomPanelTab:
        | (
            | "CEILING_MULTIPLACER_PRODUCTS"
            | "CEILING_STANDARD_ROOM"
            | "CEILING_VALIDATIONS"
            | "CEILING_AI_PREDICTIONS"
            | "CEILING_COMMENTS"
            | "ROOM_SECTION_VIEWS"
            | "RFP_STANDARD_ROOM_DIFF"
            | "ROOM_SPECIFIED_ARTICLES"
            | "ROOM_NUMBERING_DETAILS"
            | "ROOM_INFO"
            | "ROOM_DROFUS_CHANGES"
            | null
          )
        | null;
      modules: {
        ROOM_VALIDATION: {
          occurrences: {
            filterMode: "listType" | "responsibility";
            listType: string | null;
            responsibility: string | null;
            tableFilter: {
              search: string;
              onlyDeviations: boolean;
            };
          };
          standardRoom: {
            discipline: ("E" | "V" | null) | null;
            tableFilter: {
              search: string;
              onlyDeviations: boolean;
            };
          };
        };
      };
    };
    kind: "preset";
    name: string;
    description?: string;
    source: "user";
    scope: "personal" | "project";
    updatedAt?: string;
  }[];
export type GetMultiplacerViewsApiArg = {
  projectNo: number;
  scope?: "personal" | "project";
};
export type GetMultiplacerViewsByViewIdApiResponse =
  /** status 200 Successful response */
    | {
        _id: string;
        projectNo: number;
        createdAt: string;
        createdBy: {
          _id: string;
          name: string;
        };
        view: {
          schemaVersion: 1;
          visibility:
            | {
                mode: "INSTANCE_CLASS";
                ifcClasses: {
                  ifcClass: string;
                  opacity: number;
                }[];
              }
            | {
                mode: "DISCIPLINE";
                disciplines: string[];
              };
          componentColorMode:
            | "SYSTEM_AND_CLASS"
            | "MULTIPLACER_COLORS"
            | "MMI"
            | "DISCIPLINE_COLORS"
            | "PRIMARY_SYSTEM";
          articleColoringId: string | null;
          roomColoringId:
            | (
                | (
                    | "SPACE_BELONG_TO_STANDARD_ROOM"
                    | "SUPPLY_AIR_FLOW"
                    | "RETURN_AIR_FLOW"
                    | "MMI"
                    | "CEILING_MMI"
                    | "DR_STATUS"
                    | "DESIGN_DEVIATION_STATUS"
                    | "ROOM_NUMBERING"
                    | "CEILING_COMMENTS"
                  )
                | string
                | "specifiedArticles.overall"
                | string
              )
            | null;
          roomPanelTab:
            | (
                | "CEILING_MULTIPLACER_PRODUCTS"
                | "CEILING_STANDARD_ROOM"
                | "CEILING_VALIDATIONS"
                | "CEILING_AI_PREDICTIONS"
                | "CEILING_COMMENTS"
                | "ROOM_SECTION_VIEWS"
                | "RFP_STANDARD_ROOM_DIFF"
                | "ROOM_SPECIFIED_ARTICLES"
                | "ROOM_NUMBERING_DETAILS"
                | "ROOM_INFO"
                | "ROOM_DROFUS_CHANGES"
                | null
              )
            | null;
          modules: {
            ROOM_VALIDATION: {
              occurrences: {
                filterMode: "listType" | "responsibility";
                listType: string | null;
                responsibility: string | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
              standardRoom: {
                discipline: ("E" | "V" | null) | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
            };
          };
        };
        kind: "preset";
        name: string;
        description?: string;
        source: "user";
        scope: "personal" | "project";
        updatedAt?: string;
      }
    | {
        _id: string;
        projectNo: number;
        createdAt: string;
        createdBy: {
          _id: string;
          name: string;
        };
        view: {
          schemaVersion: 1;
          visibility:
            | {
                mode: "INSTANCE_CLASS";
                ifcClasses: {
                  ifcClass: string;
                  opacity: number;
                }[];
              }
            | {
                mode: "DISCIPLINE";
                disciplines: string[];
              };
          componentColorMode:
            | "SYSTEM_AND_CLASS"
            | "MULTIPLACER_COLORS"
            | "MMI"
            | "DISCIPLINE_COLORS"
            | "PRIMARY_SYSTEM";
          articleColoringId: string | null;
          roomColoringId:
            | (
                | (
                    | "SPACE_BELONG_TO_STANDARD_ROOM"
                    | "SUPPLY_AIR_FLOW"
                    | "RETURN_AIR_FLOW"
                    | "MMI"
                    | "CEILING_MMI"
                    | "DR_STATUS"
                    | "DESIGN_DEVIATION_STATUS"
                    | "ROOM_NUMBERING"
                    | "CEILING_COMMENTS"
                  )
                | string
                | "specifiedArticles.overall"
                | string
              )
            | null;
          roomPanelTab:
            | (
                | "CEILING_MULTIPLACER_PRODUCTS"
                | "CEILING_STANDARD_ROOM"
                | "CEILING_VALIDATIONS"
                | "CEILING_AI_PREDICTIONS"
                | "CEILING_COMMENTS"
                | "ROOM_SECTION_VIEWS"
                | "RFP_STANDARD_ROOM_DIFF"
                | "ROOM_SPECIFIED_ARTICLES"
                | "ROOM_NUMBERING_DETAILS"
                | "ROOM_INFO"
                | "ROOM_DROFUS_CHANGES"
                | null
              )
            | null;
          modules: {
            ROOM_VALIDATION: {
              occurrences: {
                filterMode: "listType" | "responsibility";
                listType: string | null;
                responsibility: string | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
              standardRoom: {
                discipline: ("E" | "V" | null) | null;
                tableFilter: {
                  search: string;
                  onlyDeviations: boolean;
                };
              };
            };
          };
        };
        kind: "snapshot";
        context: {
          module:
            | "CEILING"
            | "ROOM_VALIDATION"
            | "EXPLORE"
            | "ROOM_NUMBERING"
            | "DROFUS_CHANGE_MANAGEMENT";
          floorName: string;
          building: string;
          camera: {
            rotation: number;
            zoom: number;
            centerWorld: {
              x: number;
              y: number;
            };
          };
          selectedSpaceNumber?: string;
        };
      };
export type GetMultiplacerViewsByViewIdApiArg = {
  viewId: string;
  projectNo: number;
};
export type PatchMultiplacerViewsByViewIdApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    projectNo: number;
    createdAt: string;
    createdBy: {
      _id: string;
      name: string;
    };
    view: {
      schemaVersion: 1;
      visibility:
        | {
            mode: "INSTANCE_CLASS";
            ifcClasses: {
              ifcClass: string;
              opacity: number;
            }[];
          }
        | {
            mode: "DISCIPLINE";
            disciplines: string[];
          };
      componentColorMode:
        | "SYSTEM_AND_CLASS"
        | "MULTIPLACER_COLORS"
        | "MMI"
        | "DISCIPLINE_COLORS"
        | "PRIMARY_SYSTEM";
      articleColoringId: string | null;
      roomColoringId:
        | (
            | (
                | "SPACE_BELONG_TO_STANDARD_ROOM"
                | "SUPPLY_AIR_FLOW"
                | "RETURN_AIR_FLOW"
                | "MMI"
                | "CEILING_MMI"
                | "DR_STATUS"
                | "DESIGN_DEVIATION_STATUS"
                | "ROOM_NUMBERING"
                | "CEILING_COMMENTS"
              )
            | string
            | "specifiedArticles.overall"
            | string
          )
        | null;
      roomPanelTab:
        | (
            | "CEILING_MULTIPLACER_PRODUCTS"
            | "CEILING_STANDARD_ROOM"
            | "CEILING_VALIDATIONS"
            | "CEILING_AI_PREDICTIONS"
            | "CEILING_COMMENTS"
            | "ROOM_SECTION_VIEWS"
            | "RFP_STANDARD_ROOM_DIFF"
            | "ROOM_SPECIFIED_ARTICLES"
            | "ROOM_NUMBERING_DETAILS"
            | "ROOM_INFO"
            | "ROOM_DROFUS_CHANGES"
            | null
          )
        | null;
      modules: {
        ROOM_VALIDATION: {
          occurrences: {
            filterMode: "listType" | "responsibility";
            listType: string | null;
            responsibility: string | null;
            tableFilter: {
              search: string;
              onlyDeviations: boolean;
            };
          };
          standardRoom: {
            discipline: ("E" | "V" | null) | null;
            tableFilter: {
              search: string;
              onlyDeviations: boolean;
            };
          };
        };
      };
    };
    kind: "preset";
    name: string;
    description?: string;
    source: "user";
    scope: "personal" | "project";
    updatedAt?: string;
  };
export type PatchMultiplacerViewsByViewIdApiArg = {
  viewId: string;
  body: {
    projectNo: number;
    changes: {
      name?: string;
      description?: string;
      view?: {
        schemaVersion: 1;
        visibility:
          | {
              mode: "INSTANCE_CLASS";
              ifcClasses: {
                ifcClass: string;
                opacity: number;
              }[];
            }
          | {
              mode: "DISCIPLINE";
              disciplines: string[];
            };
        componentColorMode:
          | "SYSTEM_AND_CLASS"
          | "MULTIPLACER_COLORS"
          | "MMI"
          | "DISCIPLINE_COLORS"
          | "PRIMARY_SYSTEM";
        articleColoringId: string | null;
        roomColoringId:
          | (
              | (
                  | "SPACE_BELONG_TO_STANDARD_ROOM"
                  | "SUPPLY_AIR_FLOW"
                  | "RETURN_AIR_FLOW"
                  | "MMI"
                  | "CEILING_MMI"
                  | "DR_STATUS"
                  | "DESIGN_DEVIATION_STATUS"
                  | "ROOM_NUMBERING"
                  | "CEILING_COMMENTS"
                )
              | string
              | "specifiedArticles.overall"
              | string
            )
          | null;
        roomPanelTab:
          | (
              | "CEILING_MULTIPLACER_PRODUCTS"
              | "CEILING_STANDARD_ROOM"
              | "CEILING_VALIDATIONS"
              | "CEILING_AI_PREDICTIONS"
              | "CEILING_COMMENTS"
              | "ROOM_SECTION_VIEWS"
              | "RFP_STANDARD_ROOM_DIFF"
              | "ROOM_SPECIFIED_ARTICLES"
              | "ROOM_NUMBERING_DETAILS"
              | "ROOM_INFO"
              | "ROOM_DROFUS_CHANGES"
              | null
            )
          | null;
        modules: {
          ROOM_VALIDATION: {
            occurrences: {
              filterMode: "listType" | "responsibility";
              listType: string | null;
              responsibility: string | null;
              tableFilter: {
                search: string;
                onlyDeviations: boolean;
              };
            };
            standardRoom: {
              discipline: ("E" | "V" | null) | null;
              tableFilter: {
                search: string;
                onlyDeviations: boolean;
              };
            };
          };
        };
      };
    };
  };
};
export type DeleteMultiplacerViewsByViewIdApiResponse =
  /** status 200 Successful response */ {
    ok: true;
  };
export type DeleteMultiplacerViewsByViewIdApiArg = {
  viewId: string;
  projectNo: number;
};
export type GetMultiplacerMigrationRunsAccessApiResponse =
  /** status 200 Successful response */ {
    allowed: boolean;
  };
export type GetMultiplacerMigrationRunsAccessApiArg = void;
export type GetMultiplacerMigrationRunsApiResponse =
  /** status 200 Successful response */ {
    target: {
      databaseName: string;
      hosts: string;
    };
    locked: boolean;
    migrations: {
      id: string;
      description: string;
      latestRun: {
        _id: string;
        migrationId: string;
        status: "running" | "success" | "failed";
        startedAt: string;
        finishedAt?: string;
        startedBy: string;
        databaseName: string;
        hosts: string;
        logs: string[];
        error?: string;
      } | null;
    }[];
  };
export type GetMultiplacerMigrationRunsApiArg = void;
export type PostMultiplacerMigrationRunsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    migrationId: string;
    status: "running" | "success" | "failed";
    startedAt: string;
    finishedAt?: string;
    startedBy: string;
    databaseName: string;
    hosts: string;
    logs: string[];
    error?: string;
  };
export type PostMultiplacerMigrationRunsApiArg = {
  body: {
    migrationId: string;
    confirmDatabaseName: string;
    confirmHosts: string;
    allowRerun?: boolean;
  };
};
export type Error = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error2 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error3 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error4 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type Error5 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export const {
  usePostMultiplacerArticlesByCompCodesQuery,
  useGetMcbimSpacesQuery,
  useGetMcbimSpacesInProjectQuery,
  useGetMcbimItemQuery,
  useGetMcbimItemsInSpaceQuery,
  useGetMcbimFileFloorVersionsQuery,
  useGetMcbimFileFloorVersionsAllQuery,
  useGetMcbimSingleMcbimSpaceQuery,
  usePostMcbimItemsQuery,
  useGetMcbimBuildingStoriesQuery,
  useGetMcbimDisciplinesQuery,
  useGetMcbimItemsUniqueClassesQuery,
  useGetMcbimCeilingLinesQuery,
  useGetMcbimPipeSeriesQuery,
  useGetMcbimFragsQuery,
  usePostMcbimItems3DByIdsQuery,
  usePostMcbimItems3DNearCoordinateQuery,
  usePostMultiplacerRoomsQuery,
  useGetMultiplacerSingleRoomQuery,
  useGetMultiplacerStandardRoomsQuery,
  usePostMultiplacerRoomsCeilingFreeTilesByFloorQuery,
  usePutMultiplacerRoomLockMutation,
  usePostMultiplacerRoomCeilingMutation,
  usePostMultiplacerAirflowsImportMutation,
  useDeleteMultiplacerRoomValidationMutation,
  usePostMultiplacerRoomValidationDecisionStatusMutation,
  usePostMultiplacerRoomValidationDecisionCommentMutation,
  usePostMultiplacerRoomValidationDecisionCommentUpdateMutation,
  usePostMultiplacerRoomValidationDecisionCommentDeleteMutation,
  usePostMultiplacerRoomCeilingCommentMutation,
  usePostMultiplacerRoomCeilingCommentUpdateMutation,
  usePostMultiplacerRoomCeilingCommentDeleteMutation,
  usePostMultiplacerRoomSnapshotTrendByKeyQuery,
  usePostMultiplacerRoomsRoomNumberingCalculateNrhMutation,
  useGetMultiplacerRoomsRoomNumberingCalculationMetadataQuery,
  usePostMultiplacerRoomsUpdateCalculatedRoomNumbersMutation,
  usePutMultiplacerRoomsRoomNumberingManualValueMutation,
  useDeleteMultiplacerRoomsRoomNumberingManualValueMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalMutation,
  useDeleteMultiplacerRoomsRoomNumberingApprovalMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalBulkMutation,
  usePostMultiplacerRoomsRoomNumberingApprovalBulkClearMutation,
  usePutMultiplacerRoomsRoomNumberingEvaluationMutation,
  usePostMultiplacerDevicesQuery,
  usePostMultiplacerDevicesSimilarRoomsWithIfcDesignQuery,
  usePostMultiplacerDevicesSimilarRoomsWithDevicesQuery,
  usePutMultiplacerDeviceUpdateMutation,
  usePostMultiplacerDeviceAddDevicesMutation,
  useGetMultiplacerMediaAssetsQuery,
  useDeleteMultiplacerMediaAssetsByKeyMutation,
  useGetMultiplacerMediaAssetsMediaAssetKeyQuery,
  usePostMultiplacerDeviceDeleteInRoomsMutation,
  useDeleteMultiplacerDeviceDeleteDeviceMutation,
  useGetAuthMeQuery,
  useGetAuthDevUsersQuery,
  useGetAuthUsersByUserIdProfilePhotoQuery,
  useGetProjectSyncRunsQuery,
  useGetMultiplacerAssetsSasQuery,
  useGetMultiplacerDrofusInterfaceOccurrencesSyncScheduleQuery,
  usePostMultiplacerDrofusInterfaceOccurrencesSyncScheduleMutation,
  useGetMultiplacerDrofusInterfaceRunsQuery,
  usePostMultiplacerDrofusInterfaceDeleteRunMutation,
  usePostMultiplacerDrofusInterfaceOccurrencesQuery,
  usePostMultiplacerDrofusInterfaceRoomChangesQuery,
  usePostMultiplacerDrofusInterfaceProjectChangeEventsQuery,
  usePostMultiplacerDrofusInterfaceProjectChangeEventAttributeOptionsQuery,
  usePostMultiplacerDrofusInterfaceProjectChangeEventMmiOptionsQuery,
  usePostMultiplacerDrofusInterfaceProjectChangeEventsByRoomQuery,
  usePostMultiplacerDrofusInterfaceArticlesQuery,
  usePostMultiplacerDrofusInterfaceOccurrenceQuery,
  usePostMultiplacerDrofusInterfaceOccurrenceByIfcGuidQuery,
  usePostMultiplacerDrofusInterfaceOccurrencesInRoomQuery,
  usePostTdroomUpsertMutation,
  useGetTdroomSingleQuery,
  useGetTdroomAllQuery,
  usePostAddProjectTdRoomsMutation,
  useGetMultiplacerDevicetypesQuery,
  usePostMultiplacerDevicetypesAggregateMutation,
  useGetMultiplacerDevicetypesStatsQuery,
  usePostMlPredictCeilingDevicesMutation,
  useGetMlPingQuery,
  usePutMultiplacerProjectsRoomSyncSettingsMutation,
  useGetMultiplacerProjectArticleValidationQuery,
  usePostMultiplacerProjectArticleValidationIgnoredMutation,
  useGetMultiplacerProjectArticleColoringQuery,
  usePutMultiplacerProjectArticleColoringMutation,
  usePostMultiplacerProjectAddProjectMutation,
  useGetMultiplacerProjectsQuery,
  usePostProjectDrofusUpdateSettingsMutation,
  useGetMultiplacerProjectsSingleProjectQuery,
  usePostMultiplacerProjectEditProjectMutation,
  usePostProjectVentilationUpdateSettingsMutation,
  usePostMultiplacerProjectsAddMemberMutation,
  usePostMultiplacerProjectsInviteByEmailMutation,
  usePostMultiplacerProjectsUpdateMemberModulesMutation,
  usePingQuery,
  usePostFunctionsDrofusOccurrencesDetailsQuery,
  usePostFunctionsDrofusArticlesDetailsQuery,
  useGetFunctionsPingQuery,
  usePostMultiplacerEnrichRoomMutation,
  usePostMultiplacerSyncStartMutation,
  usePostProjectDrofusVerifyConnectionMutation,
  usePostMultiplacerDrofusInterfaceOccurrencesSyncMutation,
  usePostMultiplacerDrofusInterfaceOccurrencesDiffLatestMutation,
  usePostFunctionsDrofusOccurrencesTestQuery,
  usePostFunctionsDrofusItemsOptionsTestQuery,
  usePostFunctionsDrofusOccurrencesOptionsTestQuery,
  usePostFunctionsDrofusApiProbeTestQuery,
  usePostFunctionsDrofusOccurrencesLogsTestQuery,
  usePostFunctionsDrofusRoomsOccurrencesValidateMutation,
  usePostFunctionsDrofusRoomsOccurrencesLiveQuery,
  usePostSharedZodPingMutation,
  useGetSharedStaticDeviceTypeSettingsQuery,
  usePostSharedCalculateEarthingMutation,
  usePostMultiplacerReleaseNotesDeployNotesMutation,
  useGetMultiplacerReleaseNotesPublishedQuery,
  useGetMultiplacerReleaseNotesDeployNotesUnpublishedQuery,
  usePostMultiplacerReleaseNotesPublishMutation,
  useDeleteMultiplacerReleaseNotesDeployNotesByDeployNoteIdChangeItemsAndChangeItemIdMediaMutation,
  useGetMultiplacerReleaseNotesStatusQuery,
  usePostMultiplacerReleaseNotesMarkSeenMutation,
  useGetRoutingGraphListQuery,
  usePostRoutingGraphSaveMutation,
  useDeleteRoutingGraphDeleteMutation,
  useGetMcappsProjectPnsQuery,
  usePostEarthingCalculateMutation,
  useGetEarthingRunsQuery,
  usePostMultiplacerViewsMutation,
  useGetMultiplacerViewsQuery,
  useGetMultiplacerViewsByViewIdQuery,
  usePatchMultiplacerViewsByViewIdMutation,
  useDeleteMultiplacerViewsByViewIdMutation,
  useGetMultiplacerMigrationRunsAccessQuery,
  useGetMultiplacerMigrationRunsQuery,
  usePostMultiplacerMigrationRunsMutation,
} = injectedRtkApi;
